// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-19T17:06:12.908Z
// Property: Central Station on Orange (ID: 5697443643523072)
// Collections: 25 amenities, 26 floorplans (live), 30 photos, 80 POIs, 25 reviews, 1 virtual tours, 6 office hours, 17 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5697443643523072",
  "property_external_id": "4816241",
  "property_zillow_url": "https://www.zillow.com/apartments/orlando-fl/central-station-on-orange/65VnVd/",
  "property_apartments_url": "https://www.apartments.com/central-station-on-orange-orlando-fl/txbekw9",
  "property_google_business_url": "https://www.google.com/maps/place/Central+Station+on+Orange/@28.5488855,-81.3794455,15z/data=!4m2!3m1!1s0x0:0x92e1b184fdf7499?sa=X&ved=2ahUKEwjpr7-o8OH2AhUGmWoFHdWTD-YQ_BJ6BAgsEAU",
  "property_linkedin_url": null,
  "property_hubspot_id": "8443831912",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "central-station-on-orange",
  "property_name": "Central Station on Orange",
  "property_website_url": "https://www.centralstationapts.com/",
  "property_domain": "https://www.centralstationapts.com/",
  "property_address": "480 N Orange Ave",
  "property_full_address": "480 N Orange Ave, Orlando, FL 32801",
  "property_address_1": "480 N Orange Ave",
  "property_address_2": null,
  "property_address_city": "Orlando",
  "property_address_state": "FL",
  "property_address_zip_full": "32801-1637",
  "property_address_zip": "32801",
  "property_address_country": "US",
  "property_address_county": "Orange County",
  "property_neighborhood_address": "Central Business District",
  "property_address_latitude": "28.5488276",
  "property_address_longitude": "-81.3801531",
  "property_email": "centralstation@alapts.com",
  "property_phone": "(407) 254-0045",
  "property_call_tracking_phone": "407-378-4882",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Downtown Orlando starts at your door.</strong> Explore studio to three-bedroom apartments with polished finishes, skyline-view spaces, and resort-style comforts in the Central Business District—then schedule a tour to see Central Station on Orange up close.</p>",
  "property_long_description": "<p><strong>Downtown Orlando starts at your door.</strong> Central Station on Orange brings studio, one-, two-, and three-bedroom apartments to the Central Business District, steps from LYNX Central Station and SunRail connections, with Creative Village, Orange County Courthouse, UCF Downtown, and Valencia College Downtown close by. From here, your <a href=\"/neighborhood\">downtown routine</a> can move from coffee and coworking to Lake Eola Park, the Kia Center, Dr. Phillips Center, and Orange Avenue dining and nightlife without leaving the urban core.</p><p>At home, the energy shifts to polished comfort: <a href=\"/amenities\">resort-style amenities</a> include a pool, expansive rooftop deck with skyline views, two-story fitness and health center, club room with demonstration kitchen, coffee bar, EV charging, and a private pet park with spa. Inside, choose from <a href=\"/floor-plans\">flexible floor plans</a> finished with GE stainless-steel Energy Star appliances, granite countertops, tile backsplashes, 42-inch cabinetry, wood-style plank flooring, in-home laundry, USB ports, and spacious walk-in closets.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019d02f2-3a17-72a4-9716-6fba939895c9.webp",
  "property_featured_image_media": {
    "alt_text": "Living room and bedroom view of a modern apartment.",
    "public_id": "019d02f2-3a17-72a4-9716-6fba939895c9",
    "storage_key": "property/5697443643523072/019d02f2-3a17-72a4-9716-6fba939895c9.webp",
    "width": 1240,
    "height": 826
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "279",
  "property_year_built": "2015",
  "property_year_renovated": "2022",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.1326164874552",
  "property_admin_fee": "300",
  "property_application_fee": "85",
  "property_fees_deposit_info": "Application Fee: $85\nAdministrative Fee: $300\nApplication Approval Fee: Starting at $399\nPet Fee: $400 for 1st pet, $300 for 2nd pet\nPet Rent Monthly: $30",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "400",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $400 for your 1st pet and an additional $300 for your 2nd pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $400 for your 1st pet and an additional $300 for your 2nd pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8726712.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://centralstationonorange.loftliving.com/login",
  "property_apply_now_url": "https://8726712.onlineleasing.realpage.com",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019e4d01-8bfa-75af-8063-1efe310eec3d.webp",
  "property_primary_logo_media": {
    "alt_text": "Central Station on Orange logo",
    "public_id": "019e4d01-8bfa-75af-8063-1efe310eec3d",
    "storage_key": "property/5697443643523072/019e4d01-8bfa-75af-8063-1efe310eec3d.webp",
    "width": 1000,
    "height": 600
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019d02f2-2aa7-759e-893e-2521953ab747.webp",
  "property_secondary_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02f2-2aa7-759e-893e-2521953ab747",
    "storage_key": "property/5697443643523072/019d02f2-2aa7-759e-893e-2521953ab747.webp",
    "width": 325,
    "height": 147
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019e4d01-8cd9-70dc-90be-fd00a574ab77.webp",
  "property_icon_media": {
    "alt_text": "A stylized black logo with a horizontal line passing through a circular 'S' shape.",
    "public_id": "019e4d01-8cd9-70dc-90be-fd00a574ab77",
    "storage_key": "property/5697443643523072/019e4d01-8cd9-70dc-90be-fd00a574ab77.webp",
    "width": 487,
    "height": 488
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019e4d01-8cd9-70dc-90be-fd00a574ab77.webp",
  "property_fav_icon_media": {
    "alt_text": "A stylized black logo with a horizontal line passing through a circular 'S' shape.",
    "public_id": "019e4d01-8cd9-70dc-90be-fd00a574ab77",
    "storage_key": "property/5697443643523072/019e4d01-8cd9-70dc-90be-fd00a574ab77.webp",
    "width": 487,
    "height": 488
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019e4d01-9072-77dc-8b32-ebab77dbfa15.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Central Station on Orange logo",
    "public_id": "019e4d01-9072-77dc-8b32-ebab77dbfa15",
    "storage_key": "property/5697443643523072/019e4d01-9072-77dc-8b32-ebab77dbfa15.webp",
    "width": 3072,
    "height": 1892
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019e4d01-8c03-775e-ad8a-f1131887e2ad.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Central Station on Orange logo",
    "public_id": "019e4d01-8c03-775e-ad8a-f1131887e2ad",
    "storage_key": "property/5697443643523072/019e4d01-8c03-775e-ad8a-f1131887e2ad.webp",
    "width": 1000,
    "height": 300
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#ffffff",
  "property_font_color": "#2e2a25",
  "property_color_4": "#467002",
  "property_color_3": "#5b9c00",
  "property_color_5": "#80767f",
  "property_color_6": "#bea18f",
  "property_color_7": "#755943",
  "property_color_8": null,
  "property_bedrooms_range": "studio - 3",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "532 - 1641",
  "property_sqft_min": "532",
  "property_sqft_max": "1641",
  "property_price_range": "1430.83 - 3210",
  "property_price_min": "1430.83",
  "property_price_max": "3210",
  "property_available_units": 8,
  "property_facebook_url": "https://www.facebook.com/CentralStationOnOrange",
  "property_instagram_url": "https://www.instagram.com/central_station_on_orange",
  "property_twitter_url": "https://twitter.com/centralstnfl",
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJGYDdkfl654gRmXTfTxgbLgk",
  "property_youtube_url": "https://www.youtube.com/@CentralStationOnOrange",
  "property_yelp_url": "https://www.yelp.com/biz/central-station-on-orange-orlando",
  "property_tiktok_url": "https://www.tiktok.com/@centralstationonorange",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Standout amenities, Downtown Orlando energy.</strong> Central Station on Orange brings the good stuff together: a resort-style pool, expansive rooftop deck with skyline views, and a two-story fitness and health center with cardio, strength, spin bikes, and virtual training. Add a club room with demonstration kitchen, specialty coffee bar, pet park, and posh spa—then head inside for granite counters, GE stainless-steel appliances, plank flooring, USB ports, in-home laundry, and walk-in closets.</p>",
  "property_home_floorplans_blurb": "<p><strong>Studio to three-bedroom floor plans in downtown Orlando.</strong> Central Station on Orange makes it easy to compare layouts with open living space, private bedrooms, and room to stretch out. Each apartment pairs polished style with practical finishes, including GE stainless-steel Energy Star appliances, granite countertops, 42-inch cabinetry with under-cabinet lighting, wood-style plank flooring, in-home laundry, USB ports, and spacious walk-in closets.</p>",
  "property_home_gallery_blurb": "<p><strong>Get a glimpse of Central Station on Orange.</strong> Preview polished Downtown Orlando apartments with granite countertops, tile backsplashes, stainless-steel appliances, sleek plank flooring, and private balconies with city views. Then explore standout amenity spaces, from the resort-style pool and rooftop deck to the club room with demonstration kitchen and sunlit two-story fitness center.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Downtown Orlando, dialed in.</strong> Step outside Central Station on Orange and connect to the city from every angle—SunRail and LYNX nearby, Lake Eola to the east, and Orange Avenue leading to Church Street dining, Wall Street Plaza, CityArts, and the Dr. Phillips Center. From coffee runs to arena nights and skyline views, this Central Business District address keeps the map moving.</p>",
  "property_home_reviews_blurb": "<p><strong>What stands out in the reviews?</strong> Residents point to attentive service, clean and secure spaces, modern apartment finishes, prompt maintenance, and downtown Orlando convenience. The team earns frequent shoutouts for being courteous, helpful, and personal, while community touches like rooftop gatherings and resident classes add to the everyday appeal.</p>",
  "property_neighborhood_blurb": "<p><strong>City energy, mapped around you.</strong> From Central Station on Orange, the Central Business District feels connected in every direction: catch SunRail or LYNX at the nearby transit hub, head east toward Lake Eola’s lakeside path and weekend market, or follow Orange Avenue toward Church Street dining, Wall Street Plaza, CityArts, and the Dr. Phillips Center.</p><p>This is Downtown Orlando at street level—coffee runs, courthouse and Creative Village access, performance nights, arena events, and skyline views all part of the same everyday grid. After exploring the map, see how the neighborhood pairs with elevated spaces at home, from the rooftop deck to the pet-friendly perks on the <a href=\"/amenities\">amenities</a> page, or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the address in person.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that keep pace with your day.</strong> At Central Station on Orange, home extends well beyond your front door—from a resort-style pool and an expansive rooftop deck with Downtown Orlando views to a two-story fitness and health center with strength equipment, cardio, spin bikes, and virtual training. Meet up in the club room with its demonstration kitchen, recharge at the specialty coffee bar, or give pets their own upgrade with the pet park and posh spa.</p><p>Inside, the details feel equally considered: gourmet kitchens with GE stainless-steel Energy Star appliances, granite counters, tile backsplashes, 42-inch cabinetry, and under-cabinet lighting, plus in-home laundry, plank flooring, USB ports, and walk-in closets. Browse the <a href=\"/gallery\">photo gallery</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how these features come together.</p>",
  "property_applynow_blurb": "<p><strong>Start your application at Central Station on Orange.</strong> Choose a studio, one-, two-, or three-bedroom <a href=\"/floor-plans\">floor plan</a> with polished finishes, in-home laundry, and access to resort-style spaces—all in Orlando’s downtown core. Apply online today and move one step closer to calling Central Station on Orange home.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong><br>Connect with the leasing team at Central Station on Orange and get the details you need about studio, one-, two-, and three-bedroom apartments in Downtown Orlando’s Central Business District.</p>",
  "property_faqs_blurb": "<p><strong>Questions before you make your move?</strong> Start here for quick answers about Central Station on Orange, from leasing details and floor plans to amenities, pet-friendly features, and everyday life in Downtown Orlando. If you need anything more specific, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that fits the way you live.</strong> Central Station on Orange gives you more than a single downtown Orlando apartment style to consider, with floor plans ranging from efficient studios to expansive one-, two-, and three-bedroom homes. Compare open living areas, private bedroom arrangements, and extra room to spread out, then narrow your search by pricing and availability right here.</p><p>Inside each home, polished details make the difference: gourmet kitchens with GE stainless-steel Energy Star appliances, granite countertops, contemporary tile backsplashes, 42-inch cabinetry with under-cabinet lighting, wood-style plank flooring, in-home washer and dryer, USB ports, and spacious walk-in closets. Explore current options, view photos in the <a href=\"/gallery\">gallery</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite floor plan in person.</p>",
  "property_gallery_blurb": "<p><strong>Picture the view before you visit.</strong> Browse the photo gallery for Central Station on Orange and see how these Downtown Orlando apartments bring polished interiors and elevated amenity spaces together. Look for bright kitchens with granite countertops, tile backsplashes, stainless-steel appliances, and islands made for everyday prep or an easy coffee break. Then move through open living areas, sleek plank flooring, and private balconies that frame the city from above.</p><p>The gallery also captures the community’s standout spaces: the <a href=\"/amenities\">resort-style pool</a>, rooftop deck with skyline views, club room with demonstration kitchen, and two-story fitness center filled with natural light. Ready for a closer look? Explore <a href=\"/virtual-tours\">virtual tours</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the spaces in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Downtown Orlando from your door.</strong> Use the interactive map to find available apartments at Central Station on Orange, then see how close you are to transit connections, downtown dining, nightlife, parks, and cultural destinations in the urban core.</p>",
  "property_pets_blurb": "<p><strong>Bring the whole routine—walks, washes, and wind-downs.</strong> At Central Station on Orange, pet-friendly apartment living is built into the day instead of added on. Step out for fresh air in the on-site pet park, then make cleanup easy at the posh spa before heading back to a home with durable wood-style plank flooring and plenty of closet space for leashes, treats, and everyday gear.</p><p>Cats and dogs are welcome here, with policy details shown below so you can plan with confidence. For an even closer look at the pet-friendly spaces and community perks, browse the <a href=\"/amenities\">amenities</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how life with pets fits in Downtown Orlando.</p>",
  "property_referafriend_blurb": "<p><strong>Share downtown living at Central Station on Orange.</strong><br>Love the skyline views, polished apartment finishes, and resort-style comforts? Invite a friend to explore our <a href=\"/floor-plans\">studio to three-bedroom floor plans</a> and see what makes life in the urban core easy to recommend.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access starts here.</strong> Manage your Central Station on Orange apartment with ease—pay rent, submit maintenance requests, and keep your account up to date, all in one convenient place designed to support your downtown Orlando routine.</p>",
  "property_reviews_blurb": "<p><strong>Real feedback, real reasons to feel at home.</strong> In reviews, residents consistently praise Central Station on Orange for its attentive team, well-kept spaces, modern apartments, and easy downtown convenience. The staff comes up again and again for being courteous, helpful, and personal—one resident simply called them “AMAZING STAFF!!!”</p><p>You’ll also see residents highlight the building’s clean, secure feel, prompt maintenance, thoughtful finishes, and engaging community touches like resident classes and rooftop gatherings. From “great amenities” to a location that keeps daily essentials close, these reviews offer a candid look at what people appreciate most about life here.</p>",
  "property_created_at": "1752256540516",
  "property_scheduletour_blurb": "<p><strong>See downtown living from the inside.</strong> Tour Central Station on Orange and experience polished apartments, skyline-view spaces, and everyday convenience steps from transit and the urban core. Schedule your visit today and picture your routine starting here.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — we received your inquiry.</strong><br>Central Station on Orange’s leasing team will be in touch soon. In the meantime, picture downtown Orlando at your door, polished apartment finishes, flexible floor plans, and resort-style spaces designed for comfort in the urban core.</p>",
  "property_virtualtours_blurb": "<p><strong>Tour the community before you arrive.</strong> The Central Station on Orange Community Tour lets you move through the amenity experience at your own pace, from polished indoor gathering spaces to the elevated spots that make downtown Orlando living feel connected and convenient. Look for the details that matter in motion: room to relax, places to recharge, fitness spaces with strength, cardio, spin, and virtual training, plus outdoor areas designed for skyline views and everyday downtime.</p><p>Use the virtual tour as your first walk-through, then compare <a href=\"/floor-plans\">studio to three-bedroom layouts</a>, browse the <a href=\"/gallery\">photo gallery</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> when you’re ready to see Central Station on Orange in person.</p>",
  "property_copyright": "2025 All Rights Reserved. Central Station on Orange",
  "property_seo_title_home": "Central Station on Orange | Apartments in Orlando, FL",
  "property_seo_description_home": "Discover your perfect home at Central Station on Orange in Orlando, FL! Our vibrant community offers a variety of spacious floor plans, including studio, one, two, and three-bedroom apartments to fit your lifestyle. Enjoy top-notch amenities such as a resort-style pool, state-of-the-art fitness center, chef's kitchen, and pet-friendly park. With features like tall ceilings, walk-in closets, and USB outlets, living here means comfort and convenience at your fingertips. Explore our beautiful apartments with stunning views and find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | studio - 3 Apartments in Orlando, FL",
  "property_seo_description_floorplans": "Discover your ideal living space at Central Station on Orange in vibrant Orlando, FL. Explore our diverse range of floor plans, including cozy studios, spacious one, two, and three-bedroom apartments. Whether you're a single professional or a growing family, we have the perfect home for you. Browse our available apartment homes today and find your dream floor plan!",
  "property_seo_title_amenities": "Amenities | Orlando, FL Apartments for Rent",
  "property_seo_description_amenities": "Discover the vibrant lifestyle at Central Station on Orange in Orlando, FL! Choose from our diverse floor plans—Studio, One, Two, or Three Bedrooms—designed to suit your needs. Enjoy top-tier amenities like a Chef's Kitchen, Fitness Center, and refreshing Pool, plus unique features such as USB outlets and walk-in closets. With a welcoming pet park and modern lounge spaces, there’s something for everyone. Explore our amazing community amenities and apartment features today!",
  "property_seo_title_gallery": "Gallery | Apartments in Orlando, FL",
  "property_seo_description_gallery": "\"Discover your dream home at Central Station on Orange in Orlando, FL! Explore our stunning photo gallery showcasing spacious floor plans including studios, one, two, and three-bedroom apartments. Enjoy top-notch amenities such as a chef's kitchen, fitness center, and pool, all with breathtaking views and modern finishes. Picture yourself living here! Visit us today to learn more!\"",
  "property_seo_title_virtualtours": "Virtual Tours | Central Station on Orange Apartments",
  "property_seo_description_virtualtours": "Explore Central Station on Orange in Orlando, FL! Take a virtual tour of our stunning apartment community featuring spacious studio, one, two, and three-bedroom floor plans. Uncover your ideal living space today—don't miss out!",
  "property_seo_title_interactivemap": "Interactive Map | Central Station on Orange Apartments",
  "property_seo_description_interactivemap": "Discover your perfect home at Central Station on Orange in Orlando, FL! Choose from a variety of floor plans, including studio, one, two, and three-bedroom apartments. Enjoy luxurious amenities like a state-of-the-art fitness center, chef's kitchen, and resort-style pool. Our interactive community map lets you easily search available apartments, view pricing, and find your ideal space. Experience the vibrant lifestyle of Downtown Orlando while relishing in the comfort of your new home. Start your journey today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Orlando, FL",
  "property_seo_description_neighborhood": "Discover the vibrant neighborhood surrounding Central Station on Orange in Orlando, FL! Explore our diverse range of floor plans, including studios, one, two, and three-bedroom apartments. See what's around our community and uncover local favorites and must-visit points of interest that make living here truly special. Start your adventure today!",
  "property_seo_title_contact": "Contact Us | Central Station on Orange",
  "property_seo_description_contact": "Discover your perfect home at Central Station on Orange in vibrant Orlando, FL! Choose from our variety of floor plans, including studios, one, two, and three-bedroom apartments. Have questions? Contact our leasing team today for personalized assistance and to learn more about our exceptional living spaces!",
  "property_seo_title_faqs": "FAQs | Apartments in Orlando, FL",
  "property_seo_description_faqs": "Explore the FAQs for Central Station on Orange in Orlando, FL! Discover everything you need to know about our stunning studio, one, two, and three-bedroom floor plans, and exceptional amenities—including a state-of-the-art fitness center, refreshing pool, pet park, and chef's kitchen. Whether you're curious about online resident services or our convenient car charging stations, our FAQs page has the answers you seek. Browse now and find out what makes Central Station on Orange your perfect home!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Orlando, FL",
  "property_seo_description_reviews": "\"Discover the vibrant lifestyle at Central Station on Orange in Orlando, FL! Explore our diverse floor plans featuring studios to three-bedroom apartments, complemented by luxurious amenities like a chef's kitchen, fitness center, and pet park. Enjoy online resident services and unwind at the pool or sundeck. Curious about life here? See what our residents have to say about their experiences in our welcoming community!\"",
  "property_seo_title_applynow": "Apply Now | Apartments in Orlando, FL",
  "property_seo_description_applynow": "Discover the perfect blend of comfort and convenience at Central Station on Orange in Orlando, FL! Explore our diverse floor plans, from cozy studios to spacious three-bedroom apartments, all equipped with modern amenities like a chef’s kitchen, fitness center, and pet park. Enjoy community features including a relaxing pool, sundeck, and lounge, all while being close to downtown Orlando's vibrant amenities. Ready to find your new home? Apply online today and start your journey with us!",
  "property_seo_title_residentaccess": "Resident Access | Central Station on Orange",
  "property_seo_description_residentaccess": "\"Welcome to Central Station on Orange in Orlando, FL! Access your resident portal to conveniently pay rent, schedule maintenance, and manage your living experience effortlessly. Log in now!\"",
  "property_seo_title_referafriend": "Refer A Friend | Central Station on Orange",
  "property_seo_description_referafriend": "\"Love living at Central Station on Orange? Share the experience! Refer a friend to our vibrant Orlando community and enjoy exclusive rewards. Great friends make great neighbors—invite your pals to join you in your perfect apartment home today!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Central Station on Orange",
  "property_seo_description_scheduletour": "Discover your next home at Central Station on Orange in vibrant Orlando, FL! Experience luxury living with stunning amenities and a welcoming community. Schedule a tour today and explore why our apartments are the perfect place for you!",
  "property_seo_title_privacy": "Privacy Policy | Central Station on Orange",
  "property_seo_description_privacy": "\"Discover peace of mind at Central Station on Orange in Orlando, FL. Our Privacy Policy outlines how we protect your personal information while offering a vibrant apartment living experience. View our privacy policy to learn more!\"",
  "property_seo_title_accessibility": "Website Accessibility | Central Station on Orange",
  "property_seo_description_accessibility": "\"Discover Central Station on Orange in Orlando, FL, where accessibility meets comfort. Our commitment to digital inclusion ensures everyone can fully experience our vibrant apartment community. Learn more about our accessibility features and how we support all residents. Join us today!\"",
  "property_seo_title_sitemap": "Sitemap | Central Station on Orange",
  "property_seo_description_sitemap": "Discover a comprehensive overview of Central Station on Orange in Orlando, FL! Explore our sitemap to easily navigate our vibrant apartment community offerings, amenities, and nearby attractions. View our website sitemap now to find your perfect home!",
  "property_seo_title_thankyou": "Thank You | Central Station on Orange",
  "property_seo_description_thankyou": "Thank you for reaching out to Central Station on Orange in Orlando, FL! Your information has been submitted, and a member of our friendly team will be in touch soon. Discover your new home in our vibrant community—where convenience meets comfort!",
  "property_seo_title_pets": "Pet Policy | Apartments in Jacksonville, FL\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234319567",
  "amenities": [
    {
      "id": "ec_4b41b6ffaebf4a7c023d2ae8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "external_id": "false",
      "title": "Resort‑Style Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_304444be55dfc2cb295822e3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "external_id": "false",
      "title": "Two‑Story Fitness & Health Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8af1b204ae0d0687f55427f5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "external_id": "false",
      "title": "Strength, Spin Bikes, Cardio Equipment & Virtual Training Studio",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_10cddff9dd3e23966146ba2e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "external_id": "false",
      "title": "Expansive Rooftop Deck w/ Downtown Orlando Views",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_41d4ad305b6b8d08a7036d10",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "external_id": "false",
      "title": "Strength & Cardio Center w/ Spin & Virtual Training",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_135052841ba6ae59ed6bfa17",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "external_id": "false",
      "title": "NGBS Green Registered",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bd66669c83498647f16f8d73",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "external_id": "false",
      "title": "Private Pet Park & Posh Spa",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a30b6e41fc2392f4d4c0905c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "external_id": "false",
      "title": "Electric‑Vehicle Charging Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e3c9455f1475c8ab72b980c0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "external_id": "false",
      "title": "Club Room w/ Full Demonstration Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a8b453cc5607c8695cc51df3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "external_id": "false",
      "title": "Specialty Coffee Bar & TV Lounge for Social Events",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_64575aba42609f8e67812b93",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "external_id": "false",
      "title": "Credit Building Services Powered by RentPlus",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d26181a5c9be96acbf038943",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "external_id": "false",
      "title": "Concierge Cleaning Services Available by Spruce",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ac77944d07996d7d8e756158",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "external_id": "false",
      "title": "Convenient 24/7 Online Resident Services",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_05d08cce4e1f1d5a7af101f7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "external_id": "false",
      "title": "American Landmark 360 Resident Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d9f544c3da6dc3591d41eb79",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "external_id": "false",
      "title": "GE Stainless‑Steel Energy Star Qualified Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4ccc62337e51ff7e04f27596",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "external_id": "false",
      "title": "Gourmet Style Kitchens",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c9df7e7568c1724cd3e96168",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "external_id": "false",
      "title": "Sleek Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d40054e443ece4388d27303a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "external_id": "false",
      "title": "Contemporary Tile Backsplash",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_af132e32fc3e143a97f503d2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "external_id": "false",
      "title": "In‑Home Washer & Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_25db1880dfb0b9018e892aa4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "external_id": "false",
      "title": "42\" Cabinetry w/ Under Cabinet Lighting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c5e6eb6f6dbcf6c32f489c1e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "external_id": "false",
      "title": "Modern Satin Hardware, Lighting and Fixtures",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_16092cd35486ef04060a2786",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "external_id": "false",
      "title": "9' Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_83733d4346a05da13bd6c55b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "external_id": "false",
      "title": "Wood‑Style Plank Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fde25c762b4c75d6aa52cdd1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "external_id": "false",
      "title": "USB Ports",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_de2830a056e7dd3cda68fe54",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "external_id": "false",
      "title": "Spacious Walk‑In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_86b494d2-490f-4e15-9d8e-60d17b95fee3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019e898b-e37e-744c-88ba-fd6aac671183.webp",
      "image_media": {
        "alt_text": "Modern lounge area with comfortable seating and stylish decor",
        "public_id": "019e898b-e37e-744c-88ba-fd6aac671183",
        "storage_key": "property/5697443643523072/019e898b-e37e-744c-88ba-fd6aac671183.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax in our stylish lounge area, featuring plush seating, contemporary tables, and elegant decor for a sophisticated ambiance.",
      "link": "",
      "alt_text": "Modern lounge area with comfortable seating and stylish decor",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8c2c3874-04bb-4984-8ea3-48d63ae25efb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019e898b-e24a-740e-b5f8-f15385b77a65.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, black granite island, and green bar stools.",
        "public_id": "019e898b-e24a-740e-b5f8-f15385b77a65",
        "storage_key": "property/5697443643523072/019e898b-e24a-740e-b5f8-f15385b77a65.webp",
        "width": 2686,
        "height": 1790
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, a sleek black granite island with seating, and ample cabinet space. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, black granite island, and green bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2a8b5dbb-3ac9-4184-8fe5-9b08b059cce7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019e898b-9c61-7759-9a62-549d2a58663d.webp",
      "image_media": {
        "alt_text": "Modern bathroom with granite countertops, white vanity, and bathtub with shower.",
        "public_id": "019e898b-9c61-7759-9a62-549d2a58663d",
        "storage_key": "property/5697443643523072/019e898b-9c61-7759-9a62-549d2a58663d.webp",
        "width": 2654,
        "height": 1768
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed bathroom featuring elegant granite countertops, a spacious vanity, and a pristine white bathtub, perfect for unwinding after a long day.",
      "link": "",
      "alt_text": "Modern bathroom with granite countertops, white vanity, and bathtub with shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9be801b1-f718-43e0-9c23-c04bc167510f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019e898b-9c67-7486-a16a-e274c1c722a2.webp",
      "image_media": {
        "alt_text": "Modern communal kitchen and lounge area with island, bar stools, and seating.",
        "public_id": "019e898b-9c67-7486-a16a-e274c1c722a2",
        "storage_key": "property/5697443643523072/019e898b-9c67-7486-a16a-e274c1c722a2.webp",
        "width": 2632,
        "height": 1754
      },
      "title": "Community",
      "description": "Enjoy this stylish communal kitchen and lounge, perfect for socializing or relaxing.",
      "link": "",
      "alt_text": "Modern communal kitchen and lounge area with island, bar stools, and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a895d42a-af36-4d85-be9c-bbad49eaa1df",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019e898b-6bad-7559-b7ad-11f14690981d.webp",
      "image_media": {
        "alt_text": "Modern apartment building lobby with white couches, a round coffee table, and a grand staircase.",
        "public_id": "019e898b-6bad-7559-b7ad-11f14690981d",
        "storage_key": "property/5697443643523072/019e898b-6bad-7559-b7ad-11f14690981d.webp",
        "width": 2688,
        "height": 1791
      },
      "title": "Community",
      "description": "Step into the inviting lobby of our community, featuring stylish seating areas and a grand staircase, perfect for welcoming residents and guests.",
      "link": "",
      "alt_text": "Modern apartment building lobby with white couches, a round coffee table, and a grand staircase.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c8d37740-bf75-40e5-90f5-522d8787ad26",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019e898b-6c7c-716e-a8f0-e27f8200bd85.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with connect four game and seating.",
        "public_id": "019e898b-6c7c-716e-a8f0-e27f8200bd85",
        "storage_key": "property/5697443643523072/019e898b-6c7c-716e-a8f0-e27f8200bd85.webp",
        "width": 2689,
        "height": 1793
      },
      "title": "Community",
      "description": "Enjoy outdoor games and relaxation in our community lounge area, featuring comfortable seating and artificial turf.",
      "link": "",
      "alt_text": "Outdoor lounge area with connect four game and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_161eb20d-1d81-4f52-b280-743300336d2d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019e898b-6bda-7270-ac95-ada7fecb5338.webp",
      "image_media": {
        "alt_text": "Living room and kitchen with modern furniture and appliances.",
        "public_id": "019e898b-6bda-7270-ac95-ada7fecb5338",
        "storage_key": "property/5697443643523072/019e898b-6bda-7270-ac95-ada7fecb5338.webp",
        "width": 2687,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Spacious living area with a modern kitchen, featuring stainless steel appliances and ample counter space.",
      "link": "",
      "alt_text": "Living room and kitchen with modern furniture and appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3f4f5b62-fca8-4a1e-93dc-4b5b7aa11b9a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019e898b-6642-7160-9747-f933f6511993.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, desk, and large window overlooking the city.",
        "public_id": "019e898b-6642-7160-9747-f933f6511993",
        "storage_key": "property/5697443643523072/019e898b-6642-7160-9747-f933f6511993.webp",
        "width": 2687,
        "height": 1791
      },
      "title": "Apartment",
      "description": "Spacious and modern bedroom featuring a comfortable queen-size bed, a dedicated workspace with a desk and chair, and a large window offering city views.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, desk, and large window overlooking the city.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d71f5f86-3ff3-4ac8-935f-dd3eb937894a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019e898b-6325-71d9-9b9b-5d9737245098.webp",
      "image_media": {
        "alt_text": "A spacious gym with multiple stationary bikes and a rowing machine.",
        "public_id": "019e898b-6325-71d9-9b9b-5d9737245098",
        "storage_key": "property/5697443643523072/019e898b-6325-71d9-9b9b-5d9737245098.webp",
        "width": 2686,
        "height": 1791
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a variety of cardio equipment to help you reach your wellness goals.",
      "link": "",
      "alt_text": "A spacious gym with multiple stationary bikes and a rowing machine.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6c1d8e23-b780-44ba-a095-47967da4227f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019e898b-5e31-752b-9347-397678d78b24.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and cabanas at a luxury apartment building.",
        "public_id": "019e898b-5e31-752b-9347-397678d78b24",
        "storage_key": "property/5697443643523072/019e898b-5e31-752b-9347-397678d78b24.webp",
        "width": 2690,
        "height": 1794
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning resort-style swimming pool, complete with comfortable lounge chairs and private cabanas for ultimate relaxation.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and cabanas at a luxury apartment building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5bca1045-ccd5-4a59-a82a-d9146453ff66",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019e898b-6292-755f-851e-0612adfb18d8.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island and living room area",
        "public_id": "019e898b-6292-755f-851e-0612adfb18d8",
        "storage_key": "property/5697443643523072/019e898b-6292-755f-851e-0612adfb18d8.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Bright and spacious open-concept living area featuring a modern kitchen with stainless steel appliances and a granite island, seamlessly flowing into a comfortable living room.",
      "link": "",
      "alt_text": "Modern kitchen with island and living room area",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0cb0192b-218e-44f4-8078-3fd2e6d2614f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019e898b-5944-7632-aa01-0c405fbe54a7.webp",
      "image_media": {
        "alt_text": "Living room with a white sofa, accent chair, ottoman, and a view of the bedroom and balcony.",
        "public_id": "019e898b-5944-7632-aa01-0c405fbe54a7",
        "storage_key": "property/5697443643523072/019e898b-5944-7632-aa01-0c405fbe54a7.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Stylish living area featuring a comfortable white sofa, a leather accent chair, and a tufted ottoman. Opens to a tranquil bedroom and a private balcony.",
      "link": "",
      "alt_text": "Living room with a white sofa, accent chair, ottoman, and a view of the bedroom and balcony.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5b3bb385-cb0b-4dba-b632-b5a99b260410",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019e898b-56fc-7182-ad39-0f13a66a8b9f.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and cabanas in a modern apartment complex.",
        "public_id": "019e898b-56fc-7182-ad39-0f13a66a8b9f",
        "storage_key": "property/5697443643523072/019e898b-56fc-7182-ad39-0f13a66a8b9f.webp",
        "width": 2691,
        "height": 1794
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our resort-style pool, surrounded by comfortable lounge chairs and private cabanas. The perfect oasis for relaxation and fun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and cabanas in a modern apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b849172d-e93e-4524-bbe1-58af36620f50",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019e898b-5616-7589-a20c-6062498bd049.webp",
      "image_media": {
        "alt_text": "Fitness center with weight machines, free weights, benches, and exercise balls.",
        "public_id": "019e898b-5616-7589-a20c-6062498bd049",
        "storage_key": "property/5697443643523072/019e898b-5616-7589-a20c-6062498bd049.webp",
        "width": 2608,
        "height": 1739
      },
      "title": "Community",
      "description": "Equipped fitness center featuring a wide range of weight machines, free weights, benches, and exercise balls for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with weight machines, free weights, benches, and exercise balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_13961357-f1cc-4467-897c-e49cf307b5d0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019e898b-4e3c-752d-aa02-a41f387a0771.webp",
      "image_media": {
        "alt_text": "Chaise lounges and seating areas on a rooftop deck.",
        "public_id": "019e898b-4e3c-752d-aa02-a41f387a0771",
        "storage_key": "property/5697443643523072/019e898b-4e3c-752d-aa02-a41f387a0771.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind on our rooftop deck, featuring comfortable chaise lounges and elegant seating areas perfect for enjoying the view.",
      "link": "",
      "alt_text": "Chaise lounges and seating areas on a rooftop deck.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_38b49e2f-f3cb-4fab-8615-41349d3afa12",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019e898b-50fa-7628-9f49-85a58c481dc3.webp",
      "image_media": {
        "alt_text": "Business center with computers and chairs",
        "public_id": "019e898b-50fa-7628-9f49-85a58c481dc3",
        "storage_key": "property/5697443643523072/019e898b-50fa-7628-9f49-85a58c481dc3.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Community",
      "description": "Use our convenient business center, equipped with computers and comfortable seating, for your work needs.",
      "link": "",
      "alt_text": "Business center with computers and chairs",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d023e2e5-bd87-437c-903e-51aa6f8a829a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019e898b-4d8c-70fc-9af4-a4efeff21ac4.webp",
      "image_media": {
        "alt_text": "Modern lobby with a living green wall, comfortable seating, and a grand staircase.",
        "public_id": "019e898b-4d8c-70fc-9af4-a4efeff21ac4",
        "storage_key": "property/5697443643523072/019e898b-4d8c-70fc-9af4-a4efeff21ac4.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Step into elegance: our lobby features a stunning living green wall, plush seating areas, and a striking staircase, offering a warm and sophisticated welcome.",
      "link": "",
      "alt_text": "Modern lobby with a living green wall, comfortable seating, and a grand staircase.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_89be46e9-c359-4197-92fc-4695c44186c1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019e898b-48e1-72ee-8280-3f9117522e21.webp",
      "image_media": {
        "alt_text": "Outdoor grilling station and lounge area next to swimming pool at apartment complex.",
        "public_id": "019e898b-48e1-72ee-8280-3f9117522e21",
        "storage_key": "property/5697443643523072/019e898b-48e1-72ee-8280-3f9117522e21.webp",
        "width": 2691,
        "height": 1794
      },
      "title": "Community",
      "description": "Enjoy the outdoors with a built-in grilling station and comfortable lounge seating by the sparkling swimming pool.",
      "link": "",
      "alt_text": "Outdoor grilling station and lounge area next to swimming pool at apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8d09efb9-25a3-44b1-afd1-aff67413fed9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019e898b-486d-72a8-a890-b15ad9acf44d.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity, granite countertops, and walk-in shower.",
        "public_id": "019e898b-486d-72a8-a890-b15ad9acf44d",
        "storage_key": "property/5697443643523072/019e898b-486d-72a8-a890-b15ad9acf44d.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious and modern bathroom featuring a double vanity with granite countertops, sleek fixtures, and a glass-enclosed walk-in shower. Ample counter space and storage create a spa-like experience.",
      "link": "",
      "alt_text": "Modern bathroom with double vanity, granite countertops, and walk-in shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9959b743-165a-467b-a31b-ad7f06aa8fb1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019e898b-4856-76a0-91e3-2cd580909b5a.webp",
      "image_media": {
        "alt_text": "White washer and dryer with folded towels on shelf above",
        "public_id": "019e898b-4856-76a0-91e3-2cd580909b5a",
        "storage_key": "property/5697443643523072/019e898b-4856-76a0-91e3-2cd580909b5a.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "In-unit laundry room with a white GE washer and dryer set. Freshly folded towels sit on the shelf above.",
      "link": "",
      "alt_text": "White washer and dryer with folded towels on shelf above",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ba83ff24-02b2-47b1-91d7-823a7beba7f5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019e898b-3710-724d-932d-fc56d737ab1f.webp",
      "image_media": {
        "alt_text": "Resort-style lounging area with cabana and chaise lounges.",
        "public_id": "019e898b-3710-724d-932d-fc56d737ab1f",
        "storage_key": "property/5697443643523072/019e898b-3710-724d-932d-fc56d737ab1f.webp",
        "width": 2689,
        "height": 1793
      },
      "title": "Community",
      "description": "Relax in style at our resort-style outdoor lounging area, complete with a shaded cabana and comfortable chaise lounges for ultimate relaxation.",
      "link": "",
      "alt_text": "Resort-style lounging area with cabana and chaise lounges.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ed754347-cf4a-4756-973c-dfe6129e3575",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019e898b-313d-752e-abc4-01ac2f69a38f.webp",
      "image_media": {
        "alt_text": "Modern kitchen island with bar stools and stainless steel appliances.",
        "public_id": "019e898b-313d-752e-abc4-01ac2f69a38f",
        "storage_key": "property/5697443643523072/019e898b-313d-752e-abc4-01ac2f69a38f.webp",
        "width": 2598,
        "height": 1732
      },
      "title": "Apartment",
      "description": "Expansive kitchen space with a large island, contemporary bar stools, and sleek stainless steel appliances, perfect for entertaining.",
      "link": "",
      "alt_text": "Modern kitchen island with bar stools and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f75d9f71-8d25-42b5-ac15-8fd53d9c7f43",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019e898b-2dcc-77fb-b29e-eb1a977d7772.webp",
      "image_media": {
        "alt_text": "Resort-style pool with lounge chairs and cabanas.",
        "public_id": "019e898b-2dcc-77fb-b29e-eb1a977d7772",
        "storage_key": "property/5697443643523072/019e898b-2dcc-77fb-b29e-eb1a977d7772.webp",
        "width": 2689,
        "height": 1793
      },
      "title": "Community",
      "description": "Relax by the sparkling resort-style pool, complete with comfortable lounge chairs and private cabanas for ultimate relaxation. Enjoy the sun and serene atmosphere.",
      "link": "",
      "alt_text": "Resort-style pool with lounge chairs and cabanas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4ead1448-3a6b-4c5b-8c32-299f39d6fa8f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019e898b-2fb4-72c1-add1-c08b849d112f.webp",
      "image_media": {
        "alt_text": "Outdoor entertainment area with a stage, grill, and cornhole.",
        "public_id": "019e898b-2fb4-72c1-add1-c08b849d112f",
        "storage_key": "property/5697443643523072/019e898b-2fb4-72c1-add1-c08b849d112f.webp",
        "width": 2690,
        "height": 1793
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings with a stage, grill station, and games like cornhole, perfect for community events and relaxation.",
      "link": "",
      "alt_text": "Outdoor entertainment area with a stage, grill, and cornhole.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a7b61db9-daf6-4b75-a3a9-12f0a95a4624",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019e898b-2ce4-716d-a465-dbe3c601972e.webp",
      "image_media": {
        "alt_text": "Stylish bedroom with a queen-size bed, green accent bedding, a dresser, and a nightstand.",
        "public_id": "019e898b-2ce4-716d-a465-dbe3c601972e",
        "storage_key": "property/5697443643523072/019e898b-2ce4-716d-a465-dbe3c601972e.webp",
        "width": 2687,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed bedroom, featuring a plush queen-size bed, elegant decor, and ample natural light.",
      "link": "",
      "alt_text": "Stylish bedroom with a queen-size bed, green accent bedding, a dresser, and a nightstand.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_306b8453-48b4-4d13-b380-57110917f83f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019e898b-3242-7448-a7bc-26aebf47e29a.webp",
      "image_media": {
        "alt_text": "Outdoor patio with a bar, seating, and a modern gas fireplace.",
        "public_id": "019e898b-3242-7448-a7bc-26aebf47e29a",
        "storage_key": "property/5697443643523072/019e898b-3242-7448-a7bc-26aebf47e29a.webp",
        "width": 2690,
        "height": 1793
      },
      "title": "Community",
      "description": "Enjoy the outdoors on the spacious patio, complete with a full-service bar, comfortable seating, and a sleek gas fireplace perfect for evening relaxation.",
      "link": "",
      "alt_text": "Outdoor patio with a bar, seating, and a modern gas fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_39736dfb-3365-4fdb-845f-a0a373d57fdb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019e898b-321b-779d-9faa-6bbd8252a7e9.webp",
      "image_media": {
        "alt_text": "Rooftop lounge area with lounge chairs, seating areas, and a green wall with a logo.",
        "public_id": "019e898b-321b-779d-9faa-6bbd8252a7e9",
        "storage_key": "property/5697443643523072/019e898b-321b-779d-9faa-6bbd8252a7e9.webp",
        "width": 2689,
        "height": 1793
      },
      "title": "Community",
      "description": "Relax and unwind in the stylish rooftop lounge area, complete with comfortable seating, sun loungers, and scenic views.",
      "link": "",
      "alt_text": "Rooftop lounge area with lounge chairs, seating areas, and a green wall with a logo.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_226b3fdf-6910-4f33-a0f1-7af76bbf4aa1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019e898b-2ec6-725f-8369-1141653717cc.webp",
      "image_media": {
        "alt_text": "Gym equipment with treadmills and ellipticals overlooking a pool.",
        "public_id": "019e898b-2ec6-725f-8369-1141653717cc",
        "storage_key": "property/5697443643523072/019e898b-2ec6-725f-8369-1141653717cc.webp",
        "width": 2667,
        "height": 1778
      },
      "title": "Community",
      "description": "State-of-the-art fitness center with cardio machines and free weights, adjacent to a resort-style pool.",
      "link": "",
      "alt_text": "Gym equipment with treadmills and ellipticals overlooking a pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5f8b7815-be5a-48b7-96be-ec4b87f3214a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019e898b-302c-75b7-a5e0-de59e22a6725.webp",
      "image_media": {
        "alt_text": "Walk-in closet with ample shelving and hanging space, adjacent to a modern bathroom.",
        "public_id": "019e898b-302c-75b7-a5e0-de59e22a6725",
        "storage_key": "property/5697443643523072/019e898b-302c-75b7-a5e0-de59e22a6725.webp",
        "width": 2688,
        "height": 1791
      },
      "title": "Apartment",
      "description": "Experience spacious living with a generous walk-in closet, perfect for all your storage needs. This feature complements the elegant, modern bathroom.",
      "link": "",
      "alt_text": "Walk-in closet with ample shelving and hanging space, adjacent to a modern bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a4cc48c8-6f11-464f-b1bd-f09fa41b5860",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019e898b-2dab-74a7-97b9-f8057ca36a4f.webp",
      "image_media": {
        "alt_text": "Walk-in closet with shelving and hangers, leading to a bedroom.",
        "public_id": "019e898b-2dab-74a7-97b9-f8057ca36a4f",
        "storage_key": "property/5697443643523072/019e898b-2dab-74a7-97b9-f8057ca36a4f.webp",
        "width": 2686,
        "height": 1791
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample shelving and hanging space, with a view into a well-appointed bedroom.",
      "link": "",
      "alt_text": "Walk-in closet with shelving and hangers, leading to a bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_bde941f4f3249733320fd815",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Kres Chophouse",
      "poi_type": "Restaurants",
      "poi_address": "17 W Church St, Orlando, FL 32801, USA",
      "poi_short_description": "Historic building housing a modern, bustling steakhouse with happy hours and late-night dining.",
      "poi_long_description": "Historic building housing a modern, bustling steakhouse with happy hours and late-night dining.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-6586-75af-82bc-2b9b3aeff792.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-6586-75af-82bc-2b9b3aeff792",
        "storage_key": "property/5697443643523072/019f1511-6586-75af-82bc-2b9b3aeff792.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.kresrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3751986851039121597&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kres-chophouse",
      "poi_latitude": "28.5404699",
      "poi_longitude": "-81.3794042",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 407-447-7950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1cc3-7002-84c4-7d8b17bbe31a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1cc3-7002-84c4-7d8b17bbe31a",
        "storage_key": "property/5697443643523072/019f1512-1cc3-7002-84c4-7d8b17bbe31a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJx2A1E_5654gRvZAfgim8ETQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "ec_d63dbc9a40c888340d6cfd23",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "The Boheme",
      "poi_type": "Restaurants",
      "poi_address": "325 S Orange Ave, Orlando, FL 32801, USA",
      "poi_short_description": "Refined restaurant featuring a menu of classic, European-inspired meals, plus specialty cocktails, wine & beer.",
      "poi_long_description": "Refined restaurant featuring a menu of classic, European-inspired meals, plus specialty cocktails, wine & beer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-645a-7158-b40c-8e541c41647b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-645a-7158-b40c-8e541c41647b",
        "storage_key": "property/5697443643523072/019f1511-645a-7158-b40c-8e541c41647b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.marriott.com/en-us/hotels/mcoak-grand-bohemian-orlando-autograph-collection/dining/?scid=feed67b0-9a2f-4de1-8df6-114544116108",
      "poi_directions_map_url": "https://maps.google.com/?cid=17563038099921458240&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-boheme",
      "poi_latitude": "28.538595",
      "poi_longitude": "-81.378782",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 407-581-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1cbb-732c-bf07-8087a457f69b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1cbb-732c-bf07-8087a457f69b",
        "storage_key": "property/5697443643523072/019f1512-1cbb-732c-bf07-8087a457f69b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF3f9_gF754gRQFR4UhlyvPM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "ec_cfe0d4d913f766f7ada8eddd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "The Stubborn Mule",
      "poi_type": "Restaurants",
      "poi_address": "100 S Eola Dr Unit 103, Orlando, FL 32801, USA",
      "poi_short_description": "Cool venue with a contemporary feel, offering a playful menu of New American dishes and cocktails.",
      "poi_long_description": "Cool venue with a contemporary feel, offering a playful menu of New American dishes and cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-6858-7528-a424-a675ae943090.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-6858-7528-a424-a675ae943090",
        "storage_key": "property/5697443643523072/019f1511-6858-7528-a424-a675ae943090.webp",
        "width": 1024,
        "height": 577
      },
      "poi_business_url": "https://www.thestubbornmuleorlando.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10077596401075991581&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-stubborn-mule",
      "poi_latitude": "28.5410804",
      "poi_longitude": "-81.3701344",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 407-730-3400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1cc3-7002-84c4-7d8b17bbe31a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1cc3-7002-84c4-7d8b17bbe31a",
        "storage_key": "property/5697443643523072/019f1512-1cc3-7002-84c4-7d8b17bbe31a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCTo2-eJ654gRHbTji4jQ2os",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_a607f8dc09b37db6cedff0b9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "JINYA Ramen Bar - Thornton Park",
      "poi_type": "Restaurants",
      "poi_address": "8 N Summerlin Ave, Orlando, FL 32801, USA",
      "poi_short_description": "Casual eatery featuring a customizable menu of ramen bowls, including vegan options.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-64c9-74cd-bfe8-320941411d35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-64c9-74cd-bfe8-320941411d35",
        "storage_key": "property/5697443643523072/019f1511-64c9-74cd-bfe8-320941411d35.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.jinyaramenbar.com/locations/thornton-park/?utm_medium=soci&utm_source=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=11981773132473350389&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jinya-ramen-bar---thornton-park",
      "poi_latitude": "28.5428198",
      "poi_longitude": "-81.3686386",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 407-704-1825",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1cc3-7002-84c4-7d8b17bbe31a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1cc3-7002-84c4-7d8b17bbe31a",
        "storage_key": "property/5697443643523072/019f1512-1cc3-7002-84c4-7d8b17bbe31a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJmbUuXh1754gR9bhkjC7PR6Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_70a505434668d70630318cb3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "DOMU",
      "poi_type": "Restaurants",
      "poi_address": "East End Market, 3201 Corrine Dr Ste 100, Orlando, FL 32803, USA",
      "poi_short_description": "Modern restaurant/bar serving ramen & Asian small plates, plus cocktails, sake, wine & beer.",
      "poi_long_description": "Modern restaurant/bar serving ramen & Asian small plates, plus cocktails, sake, wine & beer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f150e-6b75-734d-a7e5-d14c29003eb8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-6b75-734d-a7e5-d14c29003eb8",
        "storage_key": "property/5697443643523072/019f150e-6b75-734d-a7e5-d14c29003eb8.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.domufl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5118270953128718790&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "domu",
      "poi_latitude": "28.5682793",
      "poi_longitude": "-81.3436535",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 407-960-1228",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1cc3-7002-84c4-7d8b17bbe31a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1cc3-7002-84c4-7d8b17bbe31a",
        "storage_key": "property/5697443643523072/019f1512-1cc3-7002-84c4-7d8b17bbe31a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYb7ys7N654gRxvFvaVDAB0c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "ec_86e8dc79538054abe4705c8c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "RusTeak Thornton Park",
      "poi_type": "Restaurants",
      "poi_address": "101 S Eola Dr Ste 103, Orlando, FL 32801, USA",
      "poi_short_description": "Casual joint featuring American staples such as burgers, steak, seafood and grilled plates.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-64d2-71d9-b160-ca7ab63471db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-64d2-71d9-b160-ca7ab63471db",
        "storage_key": "property/5697443643523072/019f1511-64d2-71d9-b160-ca7ab63471db.webp",
        "width": 640,
        "height": 361
      },
      "poi_business_url": "http://rusteakthorntonpark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8528241986000173411&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rusteak-thornton-park",
      "poi_latitude": "28.5409279",
      "poi_longitude": "-81.3695323",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 407-601-5219",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1cc3-7002-84c4-7d8b17bbe31a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1cc3-7002-84c4-7d8b17bbe31a",
        "storage_key": "property/5697443643523072/019f1512-1cc3-7002-84c4-7d8b17bbe31a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ83YToXx654gRY7kc1uZmWnY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_da934c90d4bbf33f56242be9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "The Hammered Lamb",
      "poi_type": "Restaurants",
      "poi_address": "1235 N Orange Ave, Orlando, FL 32804, USA",
      "poi_short_description": "Lively pub with ping pong, live music & an outdoor bar area, plus lamb items on the food menu.",
      "poi_long_description": "Lively pub with ping pong, live music & an outdoor bar area, plus lamb items on the food menu.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-671b-738b-b34c-100f280fe261.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-671b-738b-b34c-100f280fe261",
        "storage_key": "property/5697443643523072/019f1511-671b-738b-b34c-100f280fe261.webp",
        "width": 598,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17260312152745250736&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-hammered-lamb",
      "poi_latitude": "28.5626112",
      "poi_longitude": "-81.3728493",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 407-704-3200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1cc3-7002-84c4-7d8b17bbe31a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1cc3-7002-84c4-7d8b17bbe31a",
        "storage_key": "property/5697443643523072/019f1512-1cc3-7002-84c4-7d8b17bbe31a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBbPZxXRw54gRsA-9MHTyiO8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_3a864fdc934f377c0265e513",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Tin & Taco",
      "poi_type": "Restaurants",
      "poi_address": "40 W Washington St, Orlando, FL 32801, USA",
      "poi_short_description": "Snug counter-serve spot for Parmesan-crusted tacos, southwestern eats, and canned small-batch beers.",
      "poi_long_description": "Snug counter-serve spot for Parmesan-crusted tacos, southwestern eats, and canned small-batch beers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-6b29-7458-875a-16b289a34157.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-6b29-7458-875a-16b289a34157",
        "storage_key": "property/5697443643523072/019f1511-6b29-7458-875a-16b289a34157.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://tinandtaco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2888339677222093077&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tin--taco",
      "poi_latitude": "28.5432926",
      "poi_longitude": "-81.3800019",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 407-425-4340",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1cc3-7002-84c4-7d8b17bbe31a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1cc3-7002-84c4-7d8b17bbe31a",
        "storage_key": "property/5697443643523072/019f1512-1cc3-7002-84c4-7d8b17bbe31a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBQgvwP5654gRFUF9I6JxFSg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "taco_restaurant"
    },
    {
      "id": "ec_a134d5171bcc24bacfa5f681",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "White Wolf Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1829 N Orange Ave, Orlando, FL 32804, USA",
      "poi_short_description": "Quaint American cafe crafting homestyle meals in a folksy space filled with paintings.",
      "poi_long_description": "Quaint American cafe crafting homestyle meals in a folksy space filled with paintings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-679a-7613-a906-97b68a9f9f1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-679a-7613-a906-97b68a9f9f1d",
        "storage_key": "property/5697443643523072/019f1511-679a-7613-a906-97b68a9f9f1d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://whitewolfcafe.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=16873011099821640814&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "white-wolf-cafe",
      "poi_latitude": "28.5686902",
      "poi_longitude": "-81.3725098",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 407-895-9911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1d26-716b-99cf-f89dac0d77a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1d26-716b-99cf-f89dac0d77a1",
        "storage_key": "property/5697443643523072/019f1512-1d26-716b-99cf-f89dac0d77a1.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJibTs5pF654gRbowXwDL6KOo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "ec_dbe63ff1c2c92d213450b2db",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Briarpatch Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "252 N Park Ave #3814, Winter Park, FL 32789, USA",
      "poi_short_description": "Breakfast fare such as waffles & eggs Benedict plus homemade ice cream served in an airy setting.",
      "poi_long_description": "Breakfast fare such as waffles & eggs Benedict plus homemade ice cream served in an airy setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-6b1f-7538-be9f-b4869eb84a7f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-6b1f-7538-be9f-b4869eb84a7f",
        "storage_key": "property/5697443643523072/019f1511-6b1f-7538-be9f-b4869eb84a7f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.thebriarpatchrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8511034860527081043&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "briarpatch-restaurant",
      "poi_latitude": "28.599508",
      "poi_longitude": "-81.35084599999999",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 407-628-8651",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1cc3-7002-84c4-7d8b17bbe31a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1cc3-7002-84c4-7d8b17bbe31a",
        "storage_key": "property/5697443643523072/019f1512-1cc3-7002-84c4-7d8b17bbe31a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjRIOoBBw54gRU9auvBxFHXY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_69fb058583794315ded19d8c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Prato",
      "poi_type": "Restaurants",
      "poi_address": "124 N Park Ave, Winter Park, FL 32789, USA",
      "poi_short_description": "Stylish Italian eatery offering modern takes on classic dishes in rustic-chic surrounds.",
      "poi_long_description": "Stylish Italian eatery offering modern takes on classic dishes in rustic-chic surrounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-6f62-7466-aaea-62d4b33e6e6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-6f62-7466-aaea-62d4b33e6e6c",
        "storage_key": "property/5697443643523072/019f1511-6f62-7466-aaea-62d4b33e6e6c.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://www.pratoitalian.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17038801177630767387&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "prato",
      "poi_latitude": "28.5982285",
      "poi_longitude": "-81.3508746",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 407-262-0050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1cc3-7002-84c4-7d8b17bbe31a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1cc3-7002-84c4-7d8b17bbe31a",
        "storage_key": "property/5697443643523072/019f1512-1cc3-7002-84c4-7d8b17bbe31a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWUQygBBw54gRG3kwR2X7dew",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_72fa85225e876095d1a36607",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "The Ravenous Pig",
      "poi_type": "Restaurants",
      "poi_address": "565 W Fairbanks Ave, Winter Park, FL 32789, USA",
      "poi_short_description": "Stylish gastropub serving inventive New American fare, beers brewed on-site & handcrafted cocktails.",
      "poi_long_description": "Stylish gastropub serving inventive New American fare, beers brewed on-site & handcrafted cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-6e98-76ab-9e0a-fb4f4eeac43c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-6e98-76ab-9e0a-fb4f4eeac43c",
        "storage_key": "property/5697443643523072/019f1511-6e98-76ab-9e0a-fb4f4eeac43c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.theravenouspig.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6636519062438601221&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-ravenous-pig",
      "poi_latitude": "28.5933863",
      "poi_longitude": "-81.3559752",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 407-628-2333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1cc3-7002-84c4-7d8b17bbe31a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1cc3-7002-84c4-7d8b17bbe31a",
        "storage_key": "property/5697443643523072/019f1512-1cc3-7002-84c4-7d8b17bbe31a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJg433znRw54gRBeLC7eymGVw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_0b7dd45b45beccc2a9c71132",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "The Wellborn Restaurant & Bar",
      "poi_type": "Restaurants",
      "poi_address": "211 N Lucerne Cir W, Orlando, FL 32801, USA",
      "poi_short_description": "Quaint hangout offering global small plates, desserts, wine and cocktails, plus Sunday brunch.",
      "poi_long_description": "Quaint hangout offering global small plates, desserts, wine and cocktails, plus Sunday brunch.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-7658-73aa-8782-2b7d51cfda9b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-7658-73aa-8782-2b7d51cfda9b",
        "storage_key": "property/5697443643523072/019f1511-7658-73aa-8782-2b7d51cfda9b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.thewellbornorlando.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1497369237114630469&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-wellborn-restaurant--bar",
      "poi_latitude": "28.5356202",
      "poi_longitude": "-81.3753955",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 407-745-1135",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1cc3-7002-84c4-7d8b17bbe31a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1cc3-7002-84c4-7d8b17bbe31a",
        "storage_key": "property/5697443643523072/019f1512-1cc3-7002-84c4-7d8b17bbe31a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ-V-iQF754gRRbHQQ2O5xxQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_0fa215043f654bf1878d4bb2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Se7enBites",
      "poi_type": "Restaurants",
      "poi_address": "617 N Primrose Dr, Orlando, FL 32803, USA",
      "poi_short_description": "Modern bakery with seating serving breakfast & lunch eats with Southern flair, plus sweets & coffee.",
      "poi_long_description": "Modern bakery with seating serving breakfast & lunch eats with Southern flair, plus sweets & coffee.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-6fbd-70ce-8fd9-a42e26033449.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-6fbd-70ce-8fd9-a42e26033449",
        "storage_key": "property/5697443643523072/019f1511-6fbd-70ce-8fd9-a42e26033449.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.se7enbites.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10819313373266647266&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "se7enbites",
      "poi_latitude": "28.5518578",
      "poi_longitude": "-81.347139",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 407-203-0727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1cc3-7002-84c4-7d8b17bbe31a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1cc3-7002-84c4-7d8b17bbe31a",
        "storage_key": "property/5697443643523072/019f1512-1cc3-7002-84c4-7d8b17bbe31a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJu4iOBtF654gR4hgxlzDsJZY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "ec_7f493d7d3c5cd780dbbdfdf8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Publix Super Market at The Paramount on Lake Eola",
      "poi_type": "Shopping & Retail",
      "poi_address": "400 E Central Blvd, Orlando, FL 32801, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-70ee-73a2-9d93-31410f805c40.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-70ee-73a2-9d93-31410f805c40",
        "storage_key": "property/5697443643523072/019f1511-70ee-73a2-9d93-31410f805c40.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1131&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=13245226380489222983&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-the-paramount-on-lake-eola",
      "poi_latitude": "28.5421367",
      "poi_longitude": "-81.3728076",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 407-872-7201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1d91-703e-9ece-d141d05e6246.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1d91-703e-9ece-d141d05e6246",
        "storage_key": "property/5697443643523072/019f1512-1d91-703e-9ece-d141d05e6246.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxTJuLeN654gRR2uxgjd_0Lc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_bc3415bafdb769a802b230ca",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "DGX",
      "poi_type": "Shopping & Retail",
      "poi_address": "50 S Rosalind Ave Ste A, Orlando, FL 32801, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-73a7-76a0-8d51-c08933b84d92.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-73a7-76a0-8d51-c08933b84d92",
        "storage_key": "property/5697443643523072/019f1511-73a7-76a0-8d51-c08933b84d92.webp",
        "width": 1280,
        "height": 663
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/fl/orlando/21587",
      "poi_directions_map_url": "https://maps.google.com/?cid=3605572637678882717&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dgx",
      "poi_latitude": "28.5418557",
      "poi_longitude": "-81.376055",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 321-300-0722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1d83-7649-966f-3261a161edcb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1d83-7649-966f-3261a161edcb",
        "storage_key": "property/5697443643523072/019f1512-1d83-7649-966f-3261a161edcb.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJ2bndVPx654gRnc-3-DWRCTI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_11143aea0c273519d4a4ff2c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "486 N Orange Ave, Orlando, FL 32801, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-760e-72ef-983d-e2456ca6cb82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-760e-72ef-983d-e2456ca6cb82",
        "storage_key": "property/5697443643523072/019f1511-760e-72ef-983d-e2456ca6cb82.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.7-eleven.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10901204137983338190&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "28.5487643",
      "poi_longitude": "-81.379359",
      "poi_miles_from_property": "361 ft",
      "poi_walking_minutes": "1 min",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 407-697-6521",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1d83-7649-966f-3261a161edcb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1d83-7649-966f-3261a161edcb",
        "storage_key": "property/5697443643523072/019f1512-1d83-7649-966f-3261a161edcb.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJNcn2t0d754gRzuaDDGjbSJc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_e4f76f5cc9c148d4c562c229",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Eola Wine Company",
      "poi_type": "Shopping & Retail",
      "poi_address": "430 E Central Blvd, Orlando, FL 32801, USA",
      "poi_short_description": "Cozy wine bar offers fine varietals by the glass, flight & bottle, plus light fare & patio seating.",
      "poi_long_description": "Cozy wine bar offers fine varietals by the glass, flight & bottle, plus light fare & patio seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-7341-71df-abcd-e758e79c252a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-7341-71df-abcd-e758e79c252a",
        "storage_key": "property/5697443643523072/019f1511-7341-71df-abcd-e758e79c252a.webp",
        "width": 1080,
        "height": 607
      },
      "poi_business_url": "https://www.eolawinecompany.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2198810091967326092&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eola-wine-company",
      "poi_latitude": "28.542188",
      "poi_longitude": "-81.37153479999999",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 407-481-9100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1cbb-732c-bf07-8087a457f69b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1cbb-732c-bf07-8087a457f69b",
        "storage_key": "property/5697443643523072/019f1512-1cbb-732c-bf07-8087a457f69b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmfynF-N654gRjKdB_CC-gx4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wine_bar"
    },
    {
      "id": "ec_cf1ca684b18851828c4f2f48",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Orlando Farmers' Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "20 N Eola Dr, Orlando, FL 32801, USA",
      "poi_short_description": "Lakefront market on Sundays, with seasonal fruits & vegetables, prepared foods & local handicrafts.",
      "poi_long_description": "Lakefront market on Sundays, with seasonal fruits & vegetables, prepared foods & local handicrafts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-7b11-77af-b82d-a5070341fd7d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-7b11-77af-b82d-a5070341fd7d",
        "storage_key": "property/5697443643523072/019f1511-7b11-77af-b82d-a5070341fd7d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.orlandofarmersmarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15812773321273407624&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orlando-farmers-market",
      "poi_latitude": "28.542617",
      "poi_longitude": "-81.3707561",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1e05-745f-b464-eb9466baa3fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1e05-745f-b464-eb9466baa3fc",
        "storage_key": "property/5697443643523072/019f1512-1e05-745f-b464-eb9466baa3fc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJSZ_xoON654gRiHhGWI5Bcts",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "farmers_market"
    },
    {
      "id": "ec_daf0320cfc378cf9bb836c7d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Eola Wine Company",
      "poi_type": "Shopping & Retail",
      "poi_address": "430 E Central Blvd, Orlando, FL 32801, USA",
      "poi_short_description": "Cozy wine bar offers fine varietals by the glass, flight & bottle, plus light fare & patio seating.",
      "poi_long_description": "Cozy wine bar offers fine varietals by the glass, flight & bottle, plus light fare & patio seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-76c1-7273-88a9-a59102459b43.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-76c1-7273-88a9-a59102459b43",
        "storage_key": "property/5697443643523072/019f1511-76c1-7273-88a9-a59102459b43.webp",
        "width": 1080,
        "height": 607
      },
      "poi_business_url": "https://www.eolawinecompany.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2198810091967326092&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eola-wine-company",
      "poi_latitude": "28.542188",
      "poi_longitude": "-81.37153479999999",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 407-481-9100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1cbb-732c-bf07-8087a457f69b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1cbb-732c-bf07-8087a457f69b",
        "storage_key": "property/5697443643523072/019f1512-1cbb-732c-bf07-8087a457f69b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmfynF-N654gRjKdB_CC-gx4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wine_bar"
    },
    {
      "id": "ec_4572482f4d29792d05a1a7fa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "FedEx Office Print & Ship Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "47 E Robinson St Suite 105, Orlando, FL 32801, USA",
      "poi_short_description": "Chain providing office & packaging supplies, plus a variety of services such as shipping & printing.",
      "poi_long_description": "Chain providing office & packaging supplies, plus a variety of services such as shipping & printing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-7860-77e2-af22-740485825661.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-7860-77e2-af22-740485825661",
        "storage_key": "property/5697443643523072/019f1511-7860-77e2-af22-740485825661.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://local.fedex.com/en-us/fl/orlando/office-3994?cmp=LOC-1001545-3-1-971-1110000-US-US-EN-GPLCOPYANDPRINT",
      "poi_directions_map_url": "https://maps.google.com/?cid=10527600286462992257&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fedex-office-print--ship-center",
      "poi_latitude": "28.5459563",
      "poi_longitude": "-81.3777355",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 407-839-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1df8-74dd-b3e8-b040bed84552.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1df8-74dd-b3e8-b040bed84552",
        "storage_key": "property/5697443643523072/019f1512-1df8-74dd-b3e8-b040bed84552.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXRXi5vt654gRgV_t066MGZI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_f76a676b542220cdbb463454",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "The UPS Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "424 E Central Blvd, Orlando, FL 32801, USA",
      "poi_short_description": "Store offering shipping, packaging, printing & other services, plus office supplies.",
      "poi_long_description": "Store offering shipping, packaging, printing & other services, plus office supplies.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-7d41-740a-8a99-9288700c5d36.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-7d41-740a-8a99-9288700c5d36",
        "storage_key": "property/5697443643523072/019f1511-7d41-740a-8a99-9288700c5d36.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://locations.theupsstore.com/fl/orlando/424-e-central-blvd?utm_source=Yext&utm_medium=organic&utm_campaign=Listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=5339098578980618848&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-ups-store",
      "poi_latitude": "28.5420785",
      "poi_longitude": "-81.3719122",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 407-872-1057",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1df8-74dd-b3e8-b040bed84552.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1df8-74dd-b3e8-b040bed84552",
        "storage_key": "property/5697443643523072/019f1512-1df8-74dd-b3e8-b040bed84552.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX69YO-N654gRYMLurN5JGEo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shipping_service"
    },
    {
      "id": "ec_1528358e481d995d58737cb6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "UCF Downtown",
      "poi_type": "Education",
      "poi_address": "500 W Livingston St, Orlando, FL 32801, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-8fb7-7240-abae-49a3b8a27336.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-8fb7-7240-abae-49a3b8a27336",
        "storage_key": "property/5697443643523072/019f1511-8fb7-7240-abae-49a3b8a27336.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.ucf.edu/downtown/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2025009237500499115&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ucf-downtown",
      "poi_latitude": "28.5465336",
      "poi_longitude": "-81.3862951",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 407-823-3573",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1dec-77ee-9c32-d021b8117153.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1dec-77ee-9c32-d021b8117153",
        "storage_key": "property/5697443643523072/019f1512-1dec-77ee-9c32-d021b8117153.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJPcsWbf5654gRqxQaLCxHGhw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_86097e3df9b7ebb0b0172d89",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Valencia College Downtown Campus UnionWest",
      "poi_type": "Education",
      "poi_address": "601 W Livingston St, Orlando, FL 32801, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-8596-777a-8b86-4ee149f5df06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-8596-777a-8b86-4ee149f5df06",
        "storage_key": "property/5697443643523072/019f1511-8596-777a-8b86-4ee149f5df06.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://valenciacollege.edu/downtown",
      "poi_directions_map_url": "https://maps.google.com/?cid=11663027396340266924&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "valencia-college-downtown-campus-unionwest",
      "poi_latitude": "28.5478495",
      "poi_longitude": "-81.387525",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 407-299-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1dec-77ee-9c32-d021b8117153.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1dec-77ee-9c32-d021b8117153",
        "storage_key": "property/5697443643523072/019f1512-1dec-77ee-9c32-d021b8117153.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJp_9NswJ754gRrLeCpJ9l26E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_883c6b172b953caf80956f20",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Orange Technical College",
      "poi_type": "Education",
      "poi_address": "301 W Amelia St, Orlando, FL 32801, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-7df1-702d-ba11-ce389e8475f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-7df1-702d-ba11-ce389e8475f8",
        "storage_key": "property/5697443643523072/019f1511-7df1-702d-ba11-ce389e8475f8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.orangetechcollege.net/home",
      "poi_directions_map_url": "https://maps.google.com/?cid=10508766921672025819&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orange-technical-college",
      "poi_latitude": "28.550328",
      "poi_longitude": "-81.383783",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 407-246-7060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1dec-77ee-9c32-d021b8117153.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1dec-77ee-9c32-d021b8117153",
        "storage_key": "property/5697443643523072/019f1512-1dec-77ee-9c32-d021b8117153.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIdgzEPh654gR2-aiYdaj1pE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "ec_963db1eb766ad5cf45a1c7ed",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Lake Eola Charter School",
      "poi_type": "Education",
      "poi_address": "135 N Magnolia Ave, Orlando, FL 32801, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-808b-74da-aaef-4d14bd59ef92.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-808b-74da-aaef-4d14bd59ef92",
        "storage_key": "property/5697443643523072/019f1511-808b-74da-aaef-4d14bd59ef92.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "http://www.lecs.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=217291810809888541&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-eola-charter-school",
      "poi_latitude": "28.5442561",
      "poi_longitude": "-81.37709339999999",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 407-246-0900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1dec-77ee-9c32-d021b8117153.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1dec-77ee-9c32-d021b8117153",
        "storage_key": "property/5697443643523072/019f1512-1dec-77ee-9c32-d021b8117153.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ23YCDPx654gRHb_sK8D5AwM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_c56c39c9392127685b3fec04",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Howard Middle School",
      "poi_type": "Education",
      "poi_address": "800 E Robinson St, Orlando, FL 32801, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-8270-7129-93fb-4805614bf8fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-8270-7129-93fb-4805614bf8fd",
        "storage_key": "property/5697443643523072/019f1511-8270-7129-93fb-4805614bf8fd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://howardms.ocps.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12868406826697206613&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "howard-middle-school",
      "poi_latitude": "28.5454496",
      "poi_longitude": "-81.3669128",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 407-245-1780",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1dec-77ee-9c32-d021b8117153.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1dec-77ee-9c32-d021b8117153",
        "storage_key": "property/5697443643523072/019f1512-1dec-77ee-9c32-d021b8117153.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJv_OMoOZ654gRVat_QtTDlbI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_4cc1bac72e1906d005d64feb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Cherokee School",
      "poi_type": "Education",
      "poi_address": "550 S Eola Dr, Orlando, FL 32801, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14157098416487665799&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cherokee-school",
      "poi_latitude": "28.5355718",
      "poi_longitude": "-81.36926989999999",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1dec-77ee-9c32-d021b8117153.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1dec-77ee-9c32-d021b8117153",
        "storage_key": "property/5697443643523072/019f1512-1dec-77ee-9c32-d021b8117153.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJhVCGtB1754gRhxD-lAAeeMQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_f41305e20bfeccc92370b29e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Trinity Lutheran School Child Development Center",
      "poi_type": "Education",
      "poi_address": "123 E Livingston St, Orlando, FL 32801, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-9016-71d0-83d9-5447eb5a044a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-9016-71d0-83d9-5447eb5a044a",
        "storage_key": "property/5697443643523072/019f1511-9016-71d0-83d9-5447eb5a044a.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.trinitydowntown.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17774217182644715777&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trinity-lutheran-school-child-development-center",
      "poi_latitude": "28.5487401",
      "poi_longitude": "-81.3751393",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 407-488-1919",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1dec-77ee-9c32-d021b8117153.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1dec-77ee-9c32-d021b8117153",
        "storage_key": "property/5697443643523072/019f1512-1dec-77ee-9c32-d021b8117153.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJNVua9vp654gRAcEuFFu0qvY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_3f48c23c07c0c1b7c803f51a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "First Presbyterian Church of Orlando",
      "poi_type": "Education",
      "poi_address": "106 E Church St, Orlando, FL 32801, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-8ac8-7219-9116-0474ffb90886.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-8ac8-7219-9116-0474ffb90886",
        "storage_key": "property/5697443643523072/019f1511-8ac8-7219-9116-0474ffb90886.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.fpco.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1957265562481299785&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "first-presbyterian-church-of-orlando",
      "poi_latitude": "28.5400464",
      "poi_longitude": "-81.37645970000001",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 407-423-3441",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1da1-7628-a2ab-a31cbc34f1cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1da1-7628-a2ab-a31cbc34f1cb",
        "storage_key": "property/5697443643523072/019f1512-1da1-7628-a2ab-a31cbc34f1cb.webp",
        "width": 144,
        "height": 192
      },
      "poi_google_place_id": "ChIJpZRs6v1654gRSZHNtqiaKRs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "church"
    },
    {
      "id": "ec_3eeba4ca5d68f6db5d4cee0b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "The Christ School",
      "poi_type": "Education",
      "poi_address": "106 E Church St, Orlando, FL 32801, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-8727-764f-9b11-20d0c6d66721.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-8727-764f-9b11-20d0c6d66721",
        "storage_key": "property/5697443643523072/019f1511-8727-764f-9b11-20d0c6d66721.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://thechristschool.org/?utm_source=google&utm_medium=organic&utm_campaign=gbp_orlando",
      "poi_directions_map_url": "https://maps.google.com/?cid=11566789064189851968&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-christ-school",
      "poi_latitude": "28.540215",
      "poi_longitude": "-81.3773045",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 407-849-1665",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1dec-77ee-9c32-d021b8117153.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1dec-77ee-9c32-d021b8117153",
        "storage_key": "property/5697443643523072/019f1512-1dec-77ee-9c32-d021b8117153.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJpZRs6v1654gRQLno0l59haA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_8be156bde00375c864aa4587",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Champions at Lake Como School",
      "poi_type": "Education",
      "poi_address": "901 S Bumby Ave, Orlando, FL 32806, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-9031-759a-9edd-d80d4b09a024.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-9031-759a-9edd-d80d4b09a024",
        "storage_key": "property/5697443643523072/019f1511-9031-759a-9edd-d80d4b09a024.webp",
        "width": 1280,
        "height": 955
      },
      "poi_business_url": "https://www.discoverchampions.com/our-locations/orlando/fl/001350?utm_campaign=CHP_Local&utm_source=GMB&utm_medium=Profile&utm_content=/&_google",
      "poi_directions_map_url": "https://maps.google.com/?cid=4642324583032658750&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "champions-at-lake-como-school",
      "poi_latitude": "28.5304383",
      "poi_longitude": "-81.3506621",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 321-370-4644",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1dec-77ee-9c32-d021b8117153.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1dec-77ee-9c32-d021b8117153",
        "storage_key": "property/5697443643523072/019f1512-1dec-77ee-9c32-d021b8117153.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4S68E01754gRPpu5t5zZbEA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_c52bdb25ed09b81cafdbe07f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Dr. Phillips Center for the Performing Arts",
      "poi_type": "Entertainment",
      "poi_address": "445 S Magnolia Ave, Orlando, FL 32801, USA",
      "poi_short_description": "Large, multilevel performing arts venue showcasing Broadway plays, concerts & dance performances.",
      "poi_long_description": "Large, multilevel performing arts venue showcasing Broadway plays, concerts & dance performances.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-8f65-7643-833f-c61c15b0e1b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-8f65-7643-833f-c61c15b0e1b3",
        "storage_key": "property/5697443643523072/019f1511-8f65-7643-833f-c61c15b0e1b3.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.drphillipscenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8923264105016193393&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dr-phillips-center-for-the-performing-arts",
      "poi_latitude": "28.5378247",
      "poi_longitude": "-81.3773806",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 407-358-6603",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1df8-74dd-b3e8-b040bed84552.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1df8-74dd-b3e8-b040bed84552",
        "storage_key": "property/5697443643523072/019f1512-1df8-74dd-b3e8-b040bed84552.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-7QCIgJ754gRcfF7EG3N1Xs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_4fb4b6ca853c99c3e111c256",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Kia Center",
      "poi_type": "Entertainment",
      "poi_address": "400 W Church St, Orlando, FL 32801, USA",
      "poi_short_description": "Home of the NBA's Orlando Magic & host to other sports & music events, with many food vendors.",
      "poi_long_description": "Home of the NBA's Orlando Magic & host to other sports & music events, with many food vendors.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f150e-8a54-7348-9a04-2d4136c8ed60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-8a54-7348-9a04-2d4136c8ed60",
        "storage_key": "property/5697443643523072/019f150e-8a54-7348-9a04-2d4136c8ed60.webp",
        "width": 1280,
        "height": 848
      },
      "poi_business_url": "https://www.kiacenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17854814920010600848&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kia-center",
      "poi_latitude": "28.5392214",
      "poi_longitude": "-81.3838535",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 407-440-7900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1df8-74dd-b3e8-b040bed84552.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1df8-74dd-b3e8-b040bed84552",
        "storage_key": "property/5697443643523072/019f1512-1df8-74dd-b3e8-b040bed84552.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVcr7Ufp654gRkJGTJZILyfc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "ec_3caed13eb69ae1f8c45a4f27",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Lake Eola Park",
      "poi_type": "Entertainment",
      "poi_address": "512 E Washington St, Orlando, FL 32801, USA",
      "poi_short_description": "Popular spot for walking, special events, feeding the swans & renting swan-shaped paddleboats.",
      "poi_long_description": "Popular spot for walking, special events, feeding the swans & renting swan-shaped paddleboats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f150e-dc56-73be-90a7-586549cf4e8a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-dc56-73be-90a7-586549cf4e8a",
        "storage_key": "property/5697443643523072/019f150e-dc56-73be-90a7-586549cf4e8a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.orlando.gov/Parks-the-Environment/Directory/Lake-Eola-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=17813674956509683155&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-eola-park",
      "poi_latitude": "28.5427628",
      "poi_longitude": "-81.37092919999999",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 407-246-4484",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1d98-7655-a74b-159affee1358.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1d98-7655-a74b-159affee1358",
        "storage_key": "property/5697443643523072/019f1512-1d98-7655-a74b-159affee1358.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJu3hNU-N654gR0x0I9_3iNvc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_57021be84911fc9cb6ceb226",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Orlando Science Center",
      "poi_type": "Entertainment",
      "poi_address": "777 E Princeton St, Orlando, FL 32803, USA",
      "poi_short_description": "Venerable science center with hands-on exhibits & planetarium shows, plus giant-screen & 3-D films.",
      "poi_long_description": "Venerable science center with hands-on exhibits & planetarium shows, plus giant-screen & 3-D films.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f150e-ad8a-73c5-8f7d-004f28f2686f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-ad8a-73c5-8f7d-004f28f2686f",
        "storage_key": "property/5697443643523072/019f150e-ad8a-73c5-8f7d-004f28f2686f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.osc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13044009956314809596&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orlando-science-center",
      "poi_latitude": "28.5722626",
      "poi_longitude": "-81.3682645",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 407-514-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-217e-762e-ad7d-3dc6580bc350.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-217e-762e-ad7d-3dc6580bc350",
        "storage_key": "property/5697443643523072/019f1512-217e-762e-ad7d-3dc6580bc350.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJo2bql5B654gR_ITN9PGhBbU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_ef2904e4eeea06931760145b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Orlando Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "2416 N Mills Ave, Orlando, FL 32803, USA",
      "poi_short_description": "Visiting exhibits join modern American graphics & African artifacts in a contemporary space.",
      "poi_long_description": "Visiting exhibits join modern American graphics & African artifacts in a contemporary space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-b297-75ca-9fa9-bc651da31fc2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-b297-75ca-9fa9-bc651da31fc2",
        "storage_key": "property/5697443643523072/019f1511-b297-75ca-9fa9-bc651da31fc2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://omart.org/?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=10261692283535246221&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orlando-museum-of-art",
      "poi_latitude": "28.5727501",
      "poi_longitude": "-81.3651199",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 407-896-4231",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-217e-762e-ad7d-3dc6580bc350.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-217e-762e-ad7d-3dc6580bc350",
        "storage_key": "property/5697443643523072/019f1512-217e-762e-ad7d-3dc6580bc350.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7aIAgJd654gRjUN8WsPaaI4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_8c137c99bb66974f7ec64f17",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Mennello Museum of American Art",
      "poi_type": "Entertainment",
      "poi_address": "900 E Princeton St, Orlando, FL 32803, USA",
      "poi_short_description": "Small museum dedicated to American art, with a lakeside sculpture garden on its manicured grounds.",
      "poi_long_description": "Small museum dedicated to American art, with a lakeside sculpture garden on its manicured grounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-aaba-76df-bfcb-84581bd57736.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-aaba-76df-bfcb-84581bd57736",
        "storage_key": "property/5697443643523072/019f1511-aaba-76df-bfcb-84581bd57736.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mennellomuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7535974175057793326&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mennello-museum-of-american-art",
      "poi_latitude": "28.570012",
      "poi_longitude": "-81.3673",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 407-246-4278",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-217e-762e-ad7d-3dc6580bc350.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-217e-762e-ad7d-3dc6580bc350",
        "storage_key": "property/5697443643523072/019f1512-217e-762e-ad7d-3dc6580bc350.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJlcJ_05B654gRLlHWvJUolWg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_fc073fe418942c2cce5db4f3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "CityArts",
      "poi_type": "Entertainment",
      "poi_address": "39 S Magnolia Ave, Orlando, FL 32801, USA",
      "poi_short_description": "Funky gallery collective with monthly, varied exhibitions from local & international artists.",
      "poi_long_description": "Funky gallery collective with monthly, varied exhibitions from local & international artists.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-9660-75ae-8933-5390a12a7a85.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-9660-75ae-8933-5390a12a7a85",
        "storage_key": "property/5697443643523072/019f1511-9660-75ae-8933-5390a12a7a85.webp",
        "width": 628,
        "height": 353
      },
      "poi_business_url": "https://downtownartsdistrict.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3679661682644144113&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cityarts",
      "poi_latitude": "28.5414464",
      "poi_longitude": "-81.37734669999999",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 407-648-7060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1df8-74dd-b3e8-b040bed84552.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1df8-74dd-b3e8-b040bed84552",
        "storage_key": "property/5697443643523072/019f1512-1df8-74dd-b3e8-b040bed84552.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ73e7e_5654gR8c-e_83IEDM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_gallery"
    },
    {
      "id": "ec_539f466b3f41eab8ff115cf2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "The Plaza Live",
      "poi_type": "Entertainment",
      "poi_address": "425 N Bumby Ave, Orlando, FL 32803, USA",
      "poi_short_description": "Household-name bands join local musicians & comedians at this understated former movie theater.",
      "poi_long_description": "Household-name bands join local musicians & comedians at this understated former movie theater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-acfd-776d-87b9-5ad0a26afa94.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-acfd-776d-87b9-5ad0a26afa94",
        "storage_key": "property/5697443643523072/019f1511-acfd-776d-87b9-5ad0a26afa94.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.plazaliveorlando.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2850904608295288036&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-plaza-live",
      "poi_latitude": "28.5486774",
      "poi_longitude": "-81.3513424",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 407-228-1220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1df8-74dd-b3e8-b040bed84552.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1df8-74dd-b3e8-b040bed84552",
        "storage_key": "property/5697443643523072/019f1512-1df8-74dd-b3e8-b040bed84552.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHWBuq9p654gR5Pz28aJykCc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "concert_hall"
    },
    {
      "id": "ec_d36b6573369e1e9c9114a8d5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Orlando Family Stage",
      "poi_type": "Entertainment",
      "poi_address": "1001 E Princeton St, Orlando, FL 32803, USA",
      "poi_short_description": "Casual theater staging shows and musicals geared toward children.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-a676-7093-9c73-764a412c6063.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-a676-7093-9c73-764a412c6063",
        "storage_key": "property/5697443643523072/019f1511-a676-7093-9c73-764a412c6063.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "http://www.orlandofamilystage.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11609230478762632735&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orlando-family-stage",
      "poi_latitude": "28.5708511",
      "poi_longitude": "-81.3656665",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 407-896-7365",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1df8-74dd-b3e8-b040bed84552.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1df8-74dd-b3e8-b040bed84552",
        "storage_key": "property/5697443643523072/019f1512-1df8-74dd-b3e8-b040bed84552.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJacgdI5d654gRH-ZIspxFHKE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_97604fc67578fd1d844bbab9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Orlando Shakes",
      "poi_type": "Entertainment",
      "poi_address": "812 E Rollins St, Orlando, FL 32803, USA",
      "poi_short_description": "Live theater specializing in Shakespeare but also presenting new plays, musicals & children's shows.",
      "poi_long_description": "Live theater specializing in Shakespeare but also presenting new plays, musicals & children's shows.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-a5a1-73a2-ba6d-ddd4e342ad0c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-a5a1-73a2-ba6d-ddd4e342ad0c",
        "storage_key": "property/5697443643523072/019f1511-a5a1-73a2-ba6d-ddd4e342ad0c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://orlandoshakes.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16875084408623582587&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orlando-shakes",
      "poi_latitude": "28.5731716",
      "poi_longitude": "-81.36676779999999",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 407-447-1700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1df8-74dd-b3e8-b040bed84552.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1df8-74dd-b3e8-b040bed84552",
        "storage_key": "property/5697443643523072/019f1512-1df8-74dd-b3e8-b040bed84552.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdZyA4pl654gRe829ktxXMOo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_e2fe7bd1d0714a7e8f472030",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Orlando Health Orlando Regional Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "52 W Underwood St, Orlando, FL 32806, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f150e-d0f5-75f8-9148-8ba80d2d0b01.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-d0f5-75f8-9148-8ba80d2d0b01",
        "storage_key": "property/5697443643523072/019f150e-d0f5-75f8-9148-8ba80d2d0b01.webp",
        "width": 1280,
        "height": 935
      },
      "poi_business_url": "https://www.orlandohealth.com/facilities/orlando-regional-medical-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=24878703848122848&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orlando-health-orlando-regional-medical-center",
      "poi_latitude": "28.526485",
      "poi_longitude": "-81.3778912",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 321-841-5111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-257e-77fd-8c28-e728a730f978.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-257e-77fd-8c28-e728a730f978",
        "storage_key": "property/5697443643523072/019f1512-257e-77fd-8c28-e728a730f978.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-9TcQw9754gR4OlWoQxjWAA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_577eeff48b2f61fd76e58d11",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Orlando Health Arnold Palmer Hospital for Children",
      "poi_type": "Health and Wellness",
      "poi_address": "92 W Miller St, Orlando, FL 32806, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-b0a1-70e8-b344-1dc77efcef5d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-b0a1-70e8-b344-1dc77efcef5d",
        "storage_key": "property/5697443643523072/019f1511-b0a1-70e8-b344-1dc77efcef5d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.arnoldpalmerhospital.com/facilities/arnold-palmer-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=17313645339132798613&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orlando-health-arnold-palmer-hospital-for-children",
      "poi_latitude": "28.5237288",
      "poi_longitude": "-81.3797775",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 407-649-9111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-257e-77fd-8c28-e728a730f978.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-257e-77fd-8c28-e728a730f978",
        "storage_key": "property/5697443643523072/019f1512-257e-77fd-8c28-e728a730f978.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJdYyAOQl754gRlaYbTrRsRvA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_8c6f66d1e1d39f538ad7604f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "MD Now Urgent Care - Winter Park",
      "poi_type": "Health and Wellness",
      "poi_address": "7460 University Blvd Ste 110, Winter Park, FL 32792, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-a9e9-722f-b98d-762275556603.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-a9e9-722f-b98d-762275556603",
        "storage_key": "property/5697443643523072/019f1511-a9e9-722f-b98d-762275556603.webp",
        "width": 600,
        "height": 337
      },
      "poi_business_url": "https://www.mymdnow.com/locations/orlando/winter-park?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=15683996740690874468&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "md-now-urgent-care---winter-park",
      "poi_latitude": "28.5969861",
      "poi_longitude": "-81.28794529999999",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 407-410-8945",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1df8-74dd-b3e8-b040bed84552.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1df8-74dd-b3e8-b040bed84552",
        "storage_key": "property/5697443643523072/019f1512-1df8-74dd-b3e8-b040bed84552.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvedZgXFv54gRZJBDM_C_qNk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_0c60b1a87ccf470297b4fdc3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2702 S Orange Ave, Orlando, FL 32806, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-aaca-71eb-a567-d97d219b1f83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-aaca-71eb-a567-d97d219b1f83",
        "storage_key": "property/5697443643523072/019f1511-aaca-71eb-a567-d97d219b1f83.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/orlando-fl-pharmacies/2702-s-orange-ave-orlando-fl-32806/storeid=5216?WT.mc_id=LS_GOOGLE_RX_5216",
      "poi_directions_map_url": "https://maps.google.com/?cid=14862799382006970797&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "28.5124683",
      "poi_longitude": "-81.3768559",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 407-254-5074",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-25c0-760e-b99a-2be0f9ba3397.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-25c0-760e-b99a-2be0f9ba3397",
        "storage_key": "property/5697443643523072/019f1512-25c0-760e-b99a-2be0f9ba3397.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGd6AoXN754gRrblrnEpFQ84",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_9156b52c8f1d879ea88ca26d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "408 E Michigan St, Orlando, FL 32806, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-b67c-706b-bca7-5b83b122788d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-b67c-706b-bca7-5b83b122788d",
        "storage_key": "property/5697443643523072/019f1511-b67c-706b-bca7-5b83b122788d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-408+e+michigan+st-orlando-fl-32806/id=5658",
      "poi_directions_map_url": "https://maps.google.com/?cid=12886470452047137249&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "28.5124278",
      "poi_longitude": "-81.371516",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 407-843-0956",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1df8-74dd-b3e8-b040bed84552.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1df8-74dd-b3e8-b040bed84552",
        "storage_key": "property/5697443643523072/019f1512-1df8-74dd-b3e8-b040bed84552.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9xj2n21754gR4UnWxpnw1bI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_588daa4b0e7b11a6715401a5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Devotion Yoga",
      "poi_type": "Health and Wellness",
      "poi_address": "426 E Central Blvd, Orlando, FL 32801, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-bbdd-764b-bd15-07ccbc8372d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-bbdd-764b-bd15-07ccbc8372d0",
        "storage_key": "property/5697443643523072/019f1511-bbdd-764b-bd15-07ccbc8372d0.webp",
        "width": 1280,
        "height": 914
      },
      "poi_business_url": "https://www.devotion-yoga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11717271644152603474&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "devotion-yoga",
      "poi_latitude": "28.5421661",
      "poi_longitude": "-81.3717839",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 407-528-0584",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1dec-77ee-9c32-d021b8117153.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1dec-77ee-9c32-d021b8117153",
        "storage_key": "property/5697443643523072/019f1512-1dec-77ee-9c32-d021b8117153.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJgYaFHOV754gRUiN5xnocnKI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_b72cf5bd3db5866f35555ce2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "IT GRL FIT",
      "poi_type": "Health and Wellness",
      "poi_address": "361 N Rosalind Ave Suite #9, Orlando, FL 32801, USA",
      "poi_short_description": "Fitness studio expected to open downtown in 2024 specializing in Lagree classes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-bc4a-779e-8218-e88dd97e6551.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-bc4a-779e-8218-e88dd97e6551",
        "storage_key": "property/5697443643523072/019f1511-bc4a-779e-8218-e88dd97e6551.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.itgrlfit.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17701593335391846411&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "it-grl-fit",
      "poi_latitude": "28.5469347",
      "poi_longitude": "-81.37598489999999",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 407-866-6060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1df8-74dd-b3e8-b040bed84552.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1df8-74dd-b3e8-b040bed84552",
        "storage_key": "property/5697443643523072/019f1512-1df8-74dd-b3e8-b040bed84552.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpTfS95l754gRCwB0-lmxqPU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "ec_54f964b27dd293eb2cba05d1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Solace Pilates and Yoga",
      "poi_type": "Health and Wellness",
      "poi_address": "1616 N Orange Ave, Orlando, FL 32804, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-c6e7-7698-ba65-5c2805a6ef46.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-c6e7-7698-ba65-5c2805a6ef46",
        "storage_key": "property/5697443643523072/019f1511-c6e7-7698-ba65-5c2805a6ef46.webp",
        "width": 914,
        "height": 1280
      },
      "poi_business_url": "https://solaceorlando.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13793158415140194461&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "solace-pilates-and-yoga",
      "poi_latitude": "28.565916",
      "poi_longitude": "-81.37300859999999",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 689-312-6290",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1dec-77ee-9c32-d021b8117153.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1dec-77ee-9c32-d021b8117153",
        "storage_key": "property/5697443643523072/019f1512-1dec-77ee-9c32-d021b8117153.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ44UPgz5754gRnQgf0X8ka78",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_f38de0102206e0e5d6fd3567",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Citrus Club Spa & Fitness Center",
      "poi_type": "Health and Wellness",
      "poi_address": "255 S Orange Ave #105, Orlando, FL 32801, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-c7f9-777c-bd44-396db1cb78e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-c7f9-777c-bd44-396db1cb78e3",
        "storage_key": "property/5697443643523072/019f1511-c7f9-777c-bd44-396db1cb78e3.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.invitedclubs.com/clubs/citrus-club/fitness",
      "poi_directions_map_url": "https://maps.google.com/?cid=15513882461799013933&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "citrus-club-spa--fitness-center",
      "poi_latitude": "28.5396154",
      "poi_longitude": "-81.3783062",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 407-559-3189",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1df8-74dd-b3e8-b040bed84552.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1df8-74dd-b3e8-b040bed84552",
        "storage_key": "property/5697443643523072/019f1512-1df8-74dd-b3e8-b040bed84552.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlUmbA_5654gRLV6xJudhTNc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_ab96f30ccb2a563ce4c1c572",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Downtown Orlando Boxing Club",
      "poi_type": "Health and Wellness",
      "poi_address": "Boxing Gym Entrance is in the back of the building, 1616 N Orange Ave #6412, Orlando, FL 32804, USA",
      "poi_short_description": "Gym for boxing and fitness with top-tier equipment and a family-like atmosphere.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-c0f3-7159-bc45-274fb985e0b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-c0f3-7159-bc45-274fb985e0b5",
        "storage_key": "property/5697443643523072/019f1511-c0f3-7159-bc45-274fb985e0b5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.orlandoboxingclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14644441047068337189&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "downtown-orlando-boxing-club",
      "poi_latitude": "28.5659167",
      "poi_longitude": "-81.37299250000001",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 407-601-5919",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1df8-74dd-b3e8-b040bed84552.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1df8-74dd-b3e8-b040bed84552",
        "storage_key": "property/5697443643523072/019f1512-1df8-74dd-b3e8-b040bed84552.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZUpiio1654gRJWSo8IqBO8s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_0fea1e309c092f82a6a3db9c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Lake Eola Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "512 E Washington St, Orlando, FL 32801, USA",
      "poi_short_description": "Popular spot for walking, special events, feeding the swans & renting swan-shaped paddleboats.",
      "poi_long_description": "Popular spot for walking, special events, feeding the swans & renting swan-shaped paddleboats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f150e-dc56-73be-90a7-586549cf4e8a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-dc56-73be-90a7-586549cf4e8a",
        "storage_key": "property/5697443643523072/019f150e-dc56-73be-90a7-586549cf4e8a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.orlando.gov/Parks-the-Environment/Directory/Lake-Eola-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=17813674956509683155&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-eola-park",
      "poi_latitude": "28.5427628",
      "poi_longitude": "-81.37092919999999",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 407-246-4484",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1d98-7655-a74b-159affee1358.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1d98-7655-a74b-159affee1358",
        "storage_key": "property/5697443643523072/019f1512-1d98-7655-a74b-159affee1358.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJu3hNU-N654gR0x0I9_3iNvc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_7165d8fb109a46be86c8ac1c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Constitution Green",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "300 S Summerlin Ave, Orlando, FL 32801, USA",
      "poi_short_description": "Downtown park featuring a massive oak tree, plus a fenced-in area for dogs.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-dcc6-77f8-8bdc-dc1a22a3085c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-dcc6-77f8-8bdc-dc1a22a3085c",
        "storage_key": "property/5697443643523072/019f1511-dcc6-77f8-8bdc-dc1a22a3085c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.orlando.gov/Parks-the-Environment/Directory/Constitution-Green",
      "poi_directions_map_url": "https://maps.google.com/?cid=9974072479465687766&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "constitution-green",
      "poi_latitude": "28.5388423",
      "poi_longitude": "-81.3691312",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 407-246-2283",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1d98-7655-a74b-159affee1358.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1d98-7655-a74b-159affee1358",
        "storage_key": "property/5697443643523072/019f1512-1d98-7655-a74b-159affee1358.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkx2dEeJ654gR1kqNPhMGa4o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_b2302a838a2fd40d845c6a12",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Lake Lawsona Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1019 E Jackson St, Orlando, FL 32801, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-d08a-748f-bf03-a02789312c8a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-d08a-748f-bf03-a02789312c8a",
        "storage_key": "property/5697443643523072/019f1511-d08a-748f-bf03-a02789312c8a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.orlando.gov/Parks-the-Environment/Directory/Lake-Lawsona-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=14987646709065474068&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-lawsona-park",
      "poi_latitude": "28.5408114",
      "poi_longitude": "-81.36344559999999",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 407-246-2283",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1d98-7655-a74b-159affee1358.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1d98-7655-a74b-159affee1358",
        "storage_key": "property/5697443643523072/019f1512-1d98-7655-a74b-159affee1358.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6wXryeF654gRFGDmIEbR_s8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_857159aa380453e7c6222167",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Southern Gateway",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "125 N Lucerne Cir E, Orlando, FL 32801, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.orlando.gov/Parks-the-Environment/Directory/Southern-Gateway-Lake-Lucerne",
      "poi_directions_map_url": "https://maps.google.com/?cid=7160342001505349391&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southern-gateway",
      "poi_latitude": "28.5359259",
      "poi_longitude": "-81.3763958",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 407-246-2283",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1d98-7655-a74b-159affee1358.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1d98-7655-a74b-159affee1358",
        "storage_key": "property/5697443643523072/019f1512-1d98-7655-a74b-159affee1358.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJHVSQUgJ754gRDy8J_hylXmM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_41fb5449ff7b886d670b1cf1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Greenwood Urban Wetlands",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1411 Greenwood St, Orlando, FL 32801, USA",
      "poi_short_description": "Park around Lake Greenwood featuring cypress trees, a paved trail, benches & a dog agility area.",
      "poi_long_description": "Park around Lake Greenwood featuring cypress trees, a paved trail, benches & a dog agility area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-e1e4-70d8-88df-fcc07501a454.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-e1e4-70d8-88df-fcc07501a454",
        "storage_key": "property/5697443643523072/019f1511-e1e4-70d8-88df-fcc07501a454.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.orlando.gov/Parks-the-Environment/Directory/Greenwood-Urban-Wetlands",
      "poi_directions_map_url": "https://maps.google.com/?cid=2522536286919461813&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greenwood-urban-wetlands",
      "poi_latitude": "28.5359626",
      "poi_longitude": "-81.36244380000001",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 407-246-2283",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1d98-7655-a74b-159affee1358.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1d98-7655-a74b-159affee1358",
        "storage_key": "property/5697443643523072/019f1512-1d98-7655-a74b-159affee1358.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJoc8zvSF754gRtQveUmPZASM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_3eb0f7bea155901e94e8a922",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Lake Ivanhoe Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "57 S Ivanhoe Blvd, Orlando, FL 32804, USA",
      "poi_short_description": "Narrow, tree-lined lawn beside 125-acre Lake Ivanhoe, frequented by water skiers & fishermen.",
      "poi_long_description": "Narrow, tree-lined lawn beside 125-acre Lake Ivanhoe, frequented by water skiers & fishermen.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-f06c-7403-b2a1-b2f53c58a9f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-f06c-7403-b2a1-b2f53c58a9f8",
        "storage_key": "property/5697443643523072/019f1511-f06c-7403-b2a1-b2f53c58a9f8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cityoforlando.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18165930075851433671&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-ivanhoe-park",
      "poi_latitude": "28.5638391",
      "poi_longitude": "-81.38105139999999",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 407-246-2283",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1d98-7655-a74b-159affee1358.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1d98-7655-a74b-159affee1358",
        "storage_key": "property/5697443643523072/019f1512-1d98-7655-a74b-159affee1358.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ16AQI4t654gRx6a1IShZGvw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_4cac6831b4b69762fc89b414",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Loch Haven Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "777 E Princeton St, Orlando, FL 32803, USA",
      "poi_short_description": "Green expanse between 3 lakes, home to art & science museums, a firefighting museum & 2 theaters.",
      "poi_long_description": "Green expanse between 3 lakes, home to art & science museums, a firefighting museum & 2 theaters.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-db9e-77fa-8556-4f508e8d4546.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-db9e-77fa-8556-4f508e8d4546",
        "storage_key": "property/5697443643523072/019f1511-db9e-77fa-8556-4f508e8d4546.webp",
        "width": 1280,
        "height": 722
      },
      "poi_business_url": "http://www.cityoforlando.net/parks/loch-haven-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14941151328845907358&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "loch-haven-park",
      "poi_latitude": "28.5719532",
      "poi_longitude": "-81.3662078",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 407-246-2283",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1d98-7655-a74b-159affee1358.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1d98-7655-a74b-159affee1358",
        "storage_key": "property/5697443643523072/019f1512-1d98-7655-a74b-159affee1358.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJz1lxRZd654gRnkU30_ihWc8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_7247324b932664a97139c070",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Harry P Leu Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1920 N Forest Ave, Orlando, FL 32803, USA",
      "poi_short_description": "This 50-acre botanic garden & estate on Lake Rowena includes roses, camellias & a butterfly garden.",
      "poi_long_description": "This 50-acre botanic garden & estate on Lake Rowena includes roses, camellias & a butterfly garden.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f150e-ddda-727d-a4e9-f6883539cad9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-ddda-727d-a4e9-f6883539cad9",
        "storage_key": "property/5697443643523072/019f150e-ddda-727d-a4e9-f6883539cad9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.leugardens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10851096019759427548&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harry-p-leu-gardens",
      "poi_latitude": "28.5677894",
      "poi_longitude": "-81.35712219999999",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 407-246-2620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1df8-74dd-b3e8-b040bed84552.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1df8-74dd-b3e8-b040bed84552",
        "storage_key": "property/5697443643523072/019f1512-1df8-74dd-b3e8-b040bed84552.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCRCYGrx654gR3G9qoVbWlpY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "ec_5566ac811b1833fb26d9ad6f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Mead Botanical Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1300 S Denning Dr, Winter Park, FL 32789, USA",
      "poi_short_description": "Vast, tranquil green space boasting an array of flowering gardens, wildlife habitats & pavilions.",
      "poi_long_description": "Vast, tranquil green space boasting an array of flowering gardens, wildlife habitats & pavilions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f150e-e1d8-7459-9015-a23bfc3650c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-e1d8-7459-9015-a23bfc3650c8",
        "storage_key": "property/5697443643523072/019f150e-e1d8-7459-9015-a23bfc3650c8.webp",
        "width": 1280,
        "height": 858
      },
      "poi_business_url": "https://meadgarden.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9037761965840981716&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mead-botanical-garden",
      "poi_latitude": "28.5841087",
      "poi_longitude": "-81.35865009999999",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 407-622-6323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1df8-74dd-b3e8-b040bed84552.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1df8-74dd-b3e8-b040bed84552",
        "storage_key": "property/5697443643523072/019f1512-1df8-74dd-b3e8-b040bed84552.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-Q5hegpw54gR1N58sp-UbH0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "ec_d3acc88f25d05203abff31ce",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Kraft Azalea Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1365 Alabama Dr, Winter Park, FL 32789, USA",
      "poi_short_description": "5.2-acre secluded lakefront public grounds featuring the Exedra Monument & massive cypress trees.",
      "poi_long_description": "5.2-acre secluded lakefront public grounds featuring the Exedra Monument & massive cypress trees.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-e47c-7758-b10a-9ae328619777.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-e47c-7758-b10a-9ae328619777",
        "storage_key": "property/5697443643523072/019f1511-e47c-7758-b10a-9ae328619777.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://cityofwinterpark.org/departments/parks-recreation/parks-playgrounds/parks/kraft-azalea-garden/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7447696688345069235&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kraft-azalea-garden",
      "poi_latitude": "28.6106889",
      "poi_longitude": "-81.34489169999999",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 407-599-3334",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1df8-74dd-b3e8-b040bed84552.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1df8-74dd-b3e8-b040bed84552",
        "storage_key": "property/5697443643523072/019f1512-1df8-74dd-b3e8-b040bed84552.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-TjwRCFw54gRszapr62IW2c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "garden"
    },
    {
      "id": "ec_43fc404245f7de9dae8a4d1d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Lynx Central",
      "poi_type": "Transportation & Transit",
      "poi_address": "455 N Garland Ave, Orlando, FL 32801, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-e9b6-744f-a3a1-fb7d4075510e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-e9b6-744f-a3a1-fb7d4075510e",
        "storage_key": "property/5697443643523072/019f1511-e9b6-744f-a3a1-fb7d4075510e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.golynx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5762862083644479993&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lynx-central",
      "poi_latitude": "28.548485",
      "poi_longitude": "-81.381256",
      "poi_miles_from_property": "0.1 mi",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 407-841-5969",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-26f9-778f-92e0-7873cbaf3c20.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-26f9-778f-92e0-7873cbaf3c20",
        "storage_key": "property/5697443643523072/019f1512-26f9-778f-92e0-7873cbaf3c20.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1ZcEsvl654gR-VkyOYjM-U8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "ec_ccdfd5bf066ac70a4f3fa5ce",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Church St",
      "poi_type": "Transportation & Transit",
      "poi_address": "99 W South St, Orlando, FL 32801, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f150e-f231-7157-80dd-70245c1f5d0c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-f231-7157-80dd-70245c1f5d0c",
        "storage_key": "property/5697443643523072/019f150e-f231-7157-80dd-70245c1f5d0c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.sunrail.com/station/church-street-station/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16727828110824064533&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "church-st",
      "poi_latitude": "28.5397556",
      "poi_longitude": "-81.3806525",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-29b9-72ca-88c1-e529ee2b3c5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-29b9-72ca-88c1-e529ee2b3c5c",
        "storage_key": "property/5697443643523072/019f1512-29b9-72ca-88c1-e529ee2b3c5c.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJNYWT0QF754gRFUZ2-QkvJeg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_799bf41427c4da15e674f5f9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "AdventHealth",
      "poi_type": "Transportation & Transit",
      "poi_address": "500 E Rollins St, Orlando, FL 32803, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-fe44-7572-af82-c67755329f08.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-fe44-7572-af82-c67755329f08",
        "storage_key": "property/5697443643523072/019f1511-fe44-7572-af82-c67755329f08.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.sunrail.com/station/florida-hospital-health-village",
      "poi_directions_map_url": "https://maps.google.com/?cid=2267176618978673654&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "adventhealth",
      "poi_latitude": "28.5728675",
      "poi_longitude": "-81.3715345",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 855-724-5411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-29b9-72ca-88c1-e529ee2b3c5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-29b9-72ca-88c1-e529ee2b3c5c",
        "storage_key": "property/5697443643523072/019f1512-29b9-72ca-88c1-e529ee2b3c5c.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJN1heuJp654gR9oNLeR-hdh8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_56a6aa44ed0d0a3ee59e6e8b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Orlando Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "1400 Sligh Blvd, Orlando, FL 32806, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-e9b6-744f-a3a1-fcd04622f5d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-e9b6-744f-a3a1-fcd04622f5d1",
        "storage_key": "property/5697443643523072/019f1511-e9b6-744f-a3a1-fcd04622f5d1.webp",
        "width": 1280,
        "height": 898
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=ORL",
      "poi_directions_map_url": "https://maps.google.com/?cid=5648807524922554069&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orlando-station",
      "poi_latitude": "28.5259777",
      "poi_longitude": "-81.3816666",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1df8-74dd-b3e8-b040bed84552.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1df8-74dd-b3e8-b040bed84552",
        "storage_key": "property/5697443643523072/019f1512-1df8-74dd-b3e8-b040bed84552.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy2hQWgh754gR1faP54OYZE4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "ec_25a185907918357ccc112efd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "LYMMO",
      "poi_type": "Transportation & Transit",
      "poi_address": "1339 W Colonial Dr, Orlando, FL 32804, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6206593826138594625&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lymmo",
      "poi_latitude": "28.5533075",
      "poi_longitude": "-81.4001625",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 407-843-9901",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1df8-74dd-b3e8-b040bed84552.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1df8-74dd-b3e8-b040bed84552",
        "storage_key": "property/5697443643523072/019f1512-1df8-74dd-b3e8-b040bed84552.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJffmX4EV654gRQZ0fcDNAIlY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_c9fdc8e58eb2dfaaa17ecf30",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "W Amelia St & N Orange Ave",
      "poi_type": "Transportation & Transit",
      "poi_address": "Orlando, FL 32801, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=1742217661156401120&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "w-amelia-st--n-orange-ave",
      "poi_latitude": "28.549308",
      "poi_longitude": "-81.379498",
      "poi_miles_from_property": "335 ft",
      "poi_walking_minutes": "1 min",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1df8-74dd-b3e8-b040bed84552.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1df8-74dd-b3e8-b040bed84552",
        "storage_key": "property/5697443643523072/019f1512-1df8-74dd-b3e8-b040bed84552.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo3h56_l654gR4J-jbruZLRg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_efe15be1d062f3177f1856b4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Greyhound: Bus Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "555 John Young Pkwy, Orlando, FL 32805, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-f06b-722f-9216-b6501d3f0004.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-f06b-722f-9216-b6501d3f0004",
        "storage_key": "property/5697443643523072/019f1511-f06b-722f-9216-b6501d3f0004.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.greyhound.com/bus/orlando-fl/orlando-bus-station?utm_source=google_maps&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=15153890016058103735&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greyhound-bus-station",
      "poi_latitude": "28.5478453",
      "poi_longitude": "-81.4132078",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 800-231-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1df8-74dd-b3e8-b040bed84552.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1df8-74dd-b3e8-b040bed84552",
        "storage_key": "property/5697443643523072/019f1512-1df8-74dd-b3e8-b040bed84552.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpfoWaTF654gRt1d7TK5uTdI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_cab97df3cd9a3ea9711d9650",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Orlando International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Jeff Fuqua Blvd, Orlando, FL 32827, USA",
      "poi_short_description": "High-traffic airport with a hub-&-spoke design features an on-site hotel & lots of public artwork.",
      "poi_long_description": "High-traffic airport with a hub-&-spoke design features an on-site hotel & lots of public artwork.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-f95b-7281-8ea9-4f0975790d87.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-f95b-7281-8ea9-4f0975790d87",
        "storage_key": "property/5697443643523072/019f1511-f95b-7281-8ea9-4f0975790d87.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://flymco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12486996560901693805&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orlando-international-airport",
      "poi_latitude": "28.4244422",
      "poi_longitude": "-81.3104595",
      "poi_miles_from_property": "17.3 mi",
      "poi_walking_minutes": "6 hours 21 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 407-825-2001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-2a85-7116-ab44-c4aa3e82db32.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-2a85-7116-ab44-c4aa3e82db32",
        "storage_key": "property/5697443643523072/019f1512-2a85-7116-ab44-c4aa3e82db32.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ85K0xidj54gRbeERlDa5Sq0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_69fb59c3f3103cf35ec4ad5b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Orange County Courthouse",
      "poi_type": "Major Employers & Offices",
      "poi_address": "425 N Orange Ave, Orlando, FL 32801, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-f4e1-714c-a015-55158bb2fdb4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-f4e1-714c-a015-55158bb2fdb4",
        "storage_key": "property/5697443643523072/019f1511-f4e1-714c-a015-55158bb2fdb4.webp",
        "width": 953,
        "height": 1280
      },
      "poi_business_url": "http://www.ninthcircuit.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17373259777413094356&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orange-county-courthouse",
      "poi_latitude": "28.5482276",
      "poi_longitude": "-81.37783379999999",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 407-836-2050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-2ad0-7368-8d0b-a0ec3b6987df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-2ad0-7368-8d0b-a0ec3b6987df",
        "storage_key": "property/5697443643523072/019f1512-2ad0-7368-8d0b-a0ec3b6987df.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS9xskYN754gR1BtKV7g3GvE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "ec_3931a0d7049530525e870706",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Kia Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "400 W Church St, Orlando, FL 32801, USA",
      "poi_short_description": "Home of the NBA's Orlando Magic & host to other sports & music events, with many food vendors.",
      "poi_long_description": "Home of the NBA's Orlando Magic & host to other sports & music events, with many food vendors.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f150e-8a54-7348-9a04-2d4136c8ed60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-8a54-7348-9a04-2d4136c8ed60",
        "storage_key": "property/5697443643523072/019f150e-8a54-7348-9a04-2d4136c8ed60.webp",
        "width": 1280,
        "height": 848
      },
      "poi_business_url": "https://www.kiacenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17854814920010600848&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kia-center",
      "poi_latitude": "28.5392214",
      "poi_longitude": "-81.3838535",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 407-440-7900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1df8-74dd-b3e8-b040bed84552.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1df8-74dd-b3e8-b040bed84552",
        "storage_key": "property/5697443643523072/019f1512-1df8-74dd-b3e8-b040bed84552.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVcr7Ufp654gRkJGTJZILyfc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "ec_b7b0183b466c6d1130797580",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "UCF Downtown",
      "poi_type": "Major Employers & Offices",
      "poi_address": "500 W Livingston St, Orlando, FL 32801, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-8fb7-7240-abae-49a3b8a27336.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-8fb7-7240-abae-49a3b8a27336",
        "storage_key": "property/5697443643523072/019f1511-8fb7-7240-abae-49a3b8a27336.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.ucf.edu/downtown/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2025009237500499115&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ucf-downtown",
      "poi_latitude": "28.5465336",
      "poi_longitude": "-81.3862951",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 407-823-3573",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1dec-77ee-9c32-d021b8117153.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1dec-77ee-9c32-d021b8117153",
        "storage_key": "property/5697443643523072/019f1512-1dec-77ee-9c32-d021b8117153.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJPcsWbf5654gRqxQaLCxHGhw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_187dc951fb8dff03eebc5b3c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Orlando City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "400 S Orange Ave, Orlando, FL 32801, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f150f-150d-705b-9be2-b0c7589809e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-150d-705b-9be2-b0c7589809e5",
        "storage_key": "property/5697443643523072/019f150f-150d-705b-9be2-b0c7589809e5.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.orlando.gov/Home",
      "poi_directions_map_url": "https://maps.google.com/?cid=5177279454824111065&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orlando-city-hall",
      "poi_latitude": "28.5376568",
      "poi_longitude": "-81.3795817",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 407-246-2121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-2ad0-7368-8d0b-a0ec3b6987df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-2ad0-7368-8d0b-a0ec3b6987df",
        "storage_key": "property/5697443643523072/019f1512-2ad0-7368-8d0b-a0ec3b6987df.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN0NBdAB754gR2Ru41ztk2Uc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "ec_9c0367be3347a5d961c8a6c7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Orange County Administration",
      "poi_type": "Major Employers & Offices",
      "poi_address": "201 S Rosalind Ave, Orlando, FL 32801, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-0d3e-7185-9eee-732e3dcf59fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-0d3e-7185-9eee-732e3dcf59fe",
        "storage_key": "property/5697443643523072/019f1512-0d3e-7185-9eee-732e3dcf59fe.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.ocfl.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18191742721935932487&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orange-county-administration",
      "poi_latitude": "28.5399725",
      "poi_longitude": "-81.3752557",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 407-836-3111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-2ad0-7368-8d0b-a0ec3b6987df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-2ad0-7368-8d0b-a0ec3b6987df",
        "storage_key": "property/5697443643523072/019f1512-2ad0-7368-8d0b-a0ec3b6987df.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj6kWJYN754gRR_xJIp8Ndvw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "ec_52652a632f15c61a5578d523",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "OUC—The Reliable One (Orlando Utilities Commission)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 W Anderson St, Orlando, FL 32801, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-0384-716c-88b0-499394e8ec27.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-0384-716c-88b0-499394e8ec27",
        "storage_key": "property/5697443643523072/019f1512-0384-716c-88b0-499394e8ec27.webp",
        "width": 640,
        "height": 440
      },
      "poi_business_url": "https://www.ouc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3461771879335160578&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oucthe-reliable-one-orlando-utilities-commission",
      "poi_latitude": "28.5362214",
      "poi_longitude": "-81.37972359999999",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 407-423-9018",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-1df8-74dd-b3e8-b040bed84552.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-1df8-74dd-b3e8-b040bed84552",
        "storage_key": "property/5697443643523072/019f1512-1df8-74dd-b3e8-b040bed84552.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxcPsowF754gRAms12S6vCjA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_83ce6641a58bae1dce7f748d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Orlando Health Orlando Regional Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "52 W Underwood St, Orlando, FL 32806, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f150e-d0f5-75f8-9148-8ba80d2d0b01.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-d0f5-75f8-9148-8ba80d2d0b01",
        "storage_key": "property/5697443643523072/019f150e-d0f5-75f8-9148-8ba80d2d0b01.webp",
        "width": 1280,
        "height": 935
      },
      "poi_business_url": "https://www.orlandohealth.com/facilities/orlando-regional-medical-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=24878703848122848&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orlando-health-orlando-regional-medical-center",
      "poi_latitude": "28.526485",
      "poi_longitude": "-81.3778912",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 321-841-5111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-257e-77fd-8c28-e728a730f978.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-257e-77fd-8c28-e728a730f978",
        "storage_key": "property/5697443643523072/019f1512-257e-77fd-8c28-e728a730f978.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-9TcQw9754gR4OlWoQxjWAA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_48b6b5061aaf5267623a03f0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Orlando Health Winnie Palmer Hospital for Women & Babies",
      "poi_type": "Major Employers & Offices",
      "poi_address": "83 W Miller St, Orlando, FL 32806, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-0ea6-733e-9cc0-b5819e1f4f51.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-0ea6-733e-9cc0-b5819e1f4f51",
        "storage_key": "property/5697443643523072/019f1512-0ea6-733e-9cc0-b5819e1f4f51.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.orlandohealth.com/facilities/winnie-palmer-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=4129616948969577567&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orlando-health-winnie-palmer-hospital-for-women--babies",
      "poi_latitude": "28.5243887",
      "poi_longitude": "-81.3793317",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 321-841-5274",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-257e-77fd-8c28-e728a730f978.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-257e-77fd-8c28-e728a730f978",
        "storage_key": "property/5697443643523072/019f1512-257e-77fd-8c28-e728a730f978.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJV04UKAl754gRX5zDRbxYTzk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_00a03aaea070696faf7140dc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "Orlando Health Arnold Palmer Hospital for Children",
      "poi_type": "Major Employers & Offices",
      "poi_address": "92 W Miller St, Orlando, FL 32806, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1511-b0a1-70e8-b344-1dc77efcef5d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-b0a1-70e8-b344-1dc77efcef5d",
        "storage_key": "property/5697443643523072/019f1511-b0a1-70e8-b344-1dc77efcef5d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.arnoldpalmerhospital.com/facilities/arnold-palmer-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=17313645339132798613&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orlando-health-arnold-palmer-hospital-for-children",
      "poi_latitude": "28.5237288",
      "poi_longitude": "-81.3797775",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 407-649-9111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-257e-77fd-8c28-e728a730f978.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-257e-77fd-8c28-e728a730f978",
        "storage_key": "property/5697443643523072/019f1512-257e-77fd-8c28-e728a730f978.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJdYyAOQl754gRlaYbTrRsRvA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_c0fbe3d528138c8dcab1f117",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "poi_name": "AdventHealth Orlando",
      "poi_type": "Major Employers & Offices",
      "poi_address": "601 E Rollins St, Orlando, FL 32803, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f150e-c557-7348-9885-dc0e501a16f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-c557-7348-9885-dc0e501a16f4",
        "storage_key": "property/5697443643523072/019f150e-c557-7348-9885-dc0e501a16f4.webp",
        "width": 1125,
        "height": 852
      },
      "poi_business_url": "https://www.adventhealth.com/hospital/adventhealth-orlando",
      "poi_directions_map_url": "https://maps.google.com/?cid=2606235450744802745&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "adventhealth-orlando",
      "poi_latitude": "28.5751245",
      "poi_longitude": "-81.3696726",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 407-303-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f1512-257e-77fd-8c28-e728a730f978.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-257e-77fd-8c28-e728a730f978",
        "storage_key": "property/5697443643523072/019f1512-257e-77fd-8c28-e728a730f978.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJkezOtZt654gRuY2sglU1KyQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    }
  ],
  "office_hours": [
    {
      "id": "custom_179387c9-0f83-4d5d-a692-7a0bb1537628",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_8ebc2075-945a-4d1a-b3c4-bb9bbdcc6bfc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_7a0310ec-16d1-49ab-968d-13d4e99d08e2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_08940eb9-d402-4d50-9552-693f3f7511eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_3b70054f-b942-454d-8479-52c3867b9a04",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_1992aa1e-9a4b-4d9b-b1c4-2e8c4fd255c4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_cc040772f49c156124c3abfb",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "rating": "5",
      "name": "false",
      "text": "Would recommend to all 60 and over who are still working because of the location, lights and security.",
      "date": "false",
      "title": "Would recommend to... (Verified Renter)"
    },
    {
      "id": "ec_d05eedaadae712063f7f51dd",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "rating": "5",
      "name": "false",
      "text": "Not having a guest parking makes it very challenging for friends to feel comfortable leaving their car on the streets.",
      "date": "false",
      "title": "Not having a... (Verified Renter)"
    },
    {
      "id": "ec_3d3336da11bfe4faf9dc8746",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "rating": "5",
      "name": "false",
      "text": "I love the tranquility, as well as the people that are in the building. Love the modern feel, eco, the area, the prompt maintenance staff & the courteousness of Everton in the building.",
      "date": "false",
      "title": "I love the... (Verified Renter)"
    },
    {
      "id": "ec_56fb2ea9bb9d9c9264180bcb",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "rating": "5",
      "name": "false",
      "text": "Location is awesome...the two amenities that are available are great.  The store fronts look to be coming along well.",
      "date": "false",
      "title": "Location is awesome...the... (Verified Renter)"
    },
    {
      "id": "ec_c59bbe80cafa66b49cfafe2d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "rating": "5",
      "name": "false",
      "text": "My husband and I are very happy with building amenities and location. Close to many conveniences and the I4 ramp close to community is a plus for us.\n\n\n\nOne of our concerns has been that this a non smoking community yet we have seen someone smoking in parking garage on second floor. Also, on several occasions we have had to take in the cigarette smoke odor in the same area, second floor garage, as we are entering to get in our vehicle. \n\n\n\nTo make it even more uncomfortable nicotine gum wrappers were thrown inside our trash can outside our front door. I noticed it when I stepped outside at 10 pm to grab my garbage can outside our apt door.",
      "date": "false",
      "title": "My husband and... (Verified Renter)"
    },
    {
      "id": "ec_44ea1b952395b463ab3170d1",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "rating": "5",
      "name": "false",
      "text": "Because it's a beautiful new bullding, and the management staff has just been nothing but courteous and helpful.  AMAZING STAFF!!!",
      "date": "false",
      "title": "Because it's a... (Verified Renter)"
    },
    {
      "id": "ec_be793f11aeb67cf696572a43",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "rating": "4",
      "name": "false",
      "text": "The apartments and amenities themselves are amazing. The only negatives are the limited guest parking which is understandable living downtown and the train - Just choose an apartment far from the tracks.",
      "date": "false",
      "title": "The apartments and... (Verified Renter)"
    },
    {
      "id": "ec_261a63e2123dffd1a403cc4c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "rating": "5",
      "name": "false",
      "text": "Parking is a problem. I feel that central station has done what they can do to add additional non-resident parking, however it is clear the area with growing retail needs more public/street parking. The complex should begin working with the city to expand parking availability in the area. Large sections or Orange Ave and Amelia street have excess capacity that could be made into parking.",
      "date": "false",
      "title": "Parking is a... (Verified Renter)"
    },
    {
      "id": "ec_6afe6c9455fe91a95dc8b48e",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "rating": "5",
      "name": "false",
      "text": "The community is new, has nice finishes and unique floor plans. The price is very reasonable for what was offered.",
      "date": "false",
      "title": "The community is... (Verified Renter)"
    },
    {
      "id": "ec_7b1bd46c15f6ac025cff7554",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "rating": "5",
      "name": "false",
      "text": "It's clean, well maintained, and has upgrades that would likely cost more at other buildings. The office staff is really great.",
      "date": "false",
      "title": "It's clean, well... (Verified Renter)"
    },
    {
      "id": "ec_7e0ebe6fe784aa3defedd2f4",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "rating": "5",
      "name": "false",
      "text": "The place is overall super nice and everyone was super helpful. Seems like a perfect place and there was no need to look anywhere else",
      "date": "false",
      "title": "The place is... (Verified Renter)"
    },
    {
      "id": "ec_05e86282986ae2258db41618",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "rating": "5",
      "name": "false",
      "text": "I would highly recommend this apartment community for its location, new and modern apartments, appliances, and amenities. The staff has been nothing but nice and helpful.",
      "date": "false",
      "title": "I would highly... (Verified Renter)"
    },
    {
      "id": "ec_977535c2ef917aea8aa2c34d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "rating": "5",
      "name": "false",
      "text": "I would highly recommend these apartments to friends and family. The area and staff make the environment very friendly and easy. They tend to your needs and help you as much as poweible",
      "date": "false",
      "title": "I would highly... (Verified Renter)"
    },
    {
      "id": "ec_5706fe36f068c4d5bb4cbe20",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "rating": "4",
      "name": "false",
      "text": "Apartment and amenities were amazing. Staff was helpful. I moved in within a friend primarily due to location. Building is great for getting on/off I-4, but train got annoying. Also wanted to be a little more downtown and Lake Eola area. Otherwise this apartment was great.",
      "date": "false",
      "title": "Apartment and amenities... (Verified Renter)"
    },
    {
      "id": "ec_bb242859b768e71a4de4e3e4",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "rating": "4",
      "name": "false",
      "text": "I would definitely recommend this community. I have lived in many of the downtown communities and Crescent was absolutely my favorite. Towards the end of my lease, people had started to play loud music on the weekends by the pool which was a bit obnoxious, but other than that it was a great place to live! The housekeeping staff did an unbelievable job keeping everything clean and were always so friendly. I myself don't have pets but there are so many at the complex and you hardly noticed because housekeeping kept everything so fresh.",
      "date": "false",
      "title": "I would definitely... (Verified Renter)"
    },
    {
      "id": "ec_827aa37eb6a3b60b3030240e",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "rating": "5",
      "name": "false",
      "text": "The place is greatly located right across from the courthouse and bus station which is perfect. The staff are continually nice. The wall and floors could be cuter but I love it overall.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_48312fd86cf4519df0cd3723",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "rating": "5",
      "name": "false",
      "text": "Were loving Central Station so far! Its so convenient and were just steps away from everything Downtown. The leasing staff are so helpful and the building is gorgeous. You can tell they take safety extremely seriously because they have a ton of security measures in place including a video telecom system, multiple key access points, a very secure garage door, package concierge, and cameras throughout. They are also going above and beyond to prevent the spread of COVID. The amenities are great and were excited to use the rooftop lounge once it reopens. And of course, we love our studio and all of the finishings in the kitchen and bath.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_469878b9c8a7ccfdf3cedeed",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "rating": "5",
      "name": "false",
      "text": "Vivir en Central Station es una experiencia genial. Buena ubicación, el edificio se adapta perfectamente a las mascotas. Siempre está limpio y ordenado",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_ed72fd9513276d1904a5044b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "rating": "5",
      "name": "false",
      "text": "I love living here,  best priced and great amenities! The staff is outstanding!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_a903f27f52e4afa3061f6b6a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "rating": "5",
      "name": "false",
      "text": "Great community, beautiful buildings and the leasing and move in process was easy and effortless!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_9a9d5fbcb0b402bf81c1777a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "rating": "5",
      "name": "false",
      "text": "Had an amazing tour with Jacqui! Very knowledgeable. The amenities are very well kept and a great location. ",
      "date": "false",
      "title": "Beautiful community "
    },
    {
      "id": "ec_b96760eb111bb8081fe4c4a9",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "rating": "4",
      "name": "false",
      "text": "Central Station is a secure, clean building with great amenities that is conveniently located to everything!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_3d03ff143cf83fdbe649f593",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "rating": "5",
      "name": "false",
      "text": "The apartment complex is one I hope to never leave. It is secure and safe! The office staff call you by name and are always able to assist! The floor plans are spacious and livable. Communication is important and they are on it!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_d961a5362385734b86214a11",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "rating": "5",
      "name": "false",
      "text": "I have been a resident here since August of 2022 and this review is definitely long overdue. Central Station on Orange was my first apartment living in downtown Orlando and this team has added to my experience in every way possible. Nakia and Reneil (the property managers) are hands down the best leasing team I have ever had in my years of renting. They set up weekly classes (art, cooking, etc.) in the downstairs cafe that is free to every resident. For Valentines day they hosted a “dinner under the stars” on the rooftop with a DJ, drinks, amazing food, and (the best part) the maintenance team serving the entire night with amazing dance moves, smiles and jokes. After the valentines event, they personally came to our door with a gift bag including a framed picture of my roommate and I and some goodies. Every single person from the maintenance team has done everything possible to help my roommate and I set up an amazing home and feel as safe as possible considering it is two women in the apartment. Walking around the property everyday really makes it feel like home and a big family all because of the bright smiles and care from Nakia, Reneil, the entire maintenance team, Victoria, Alex and Angie (previous leasing agent).\nPlus they have free snacks and coffee every single day in the office and who doesn’t love that?",
      "date": "false",
      "title": "Best leasing team and apartments in Downtown. "
    },
    {
      "id": "ec_e905fdd73d92ad7a25a3e9da",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "rating": "5",
      "name": "false",
      "text": "I just wanted to take a moment to express my gratitude for the exceptional service provided by the staff at our apartment complex. From the friendly and attentive management team to the diligent maintenance staff, everyone goes above and beyond to ensure that residents feel valued and well taken care of. In addition to the safety measures they took to keep us safe all day everyday. It's truly a pleasure to call this place home, thanks to the hard work and dedication of the entire team. Keep up the fantastic work!\n",
      "date": "false",
      "title": "It's truly a pleasure to call this place home"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_1a96c888407536eb66b4c066",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f14c4-8c00-704b-a463-fcca5a149270.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-8c00-704b-a463-fcca5a149270",
        "storage_key": "property/5697443643523072/019f14c4-8c00-704b-a463-fcca5a149270.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "Central Station on Orange - Community Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/gbaC9gy9zYc"
    }
  ],
  "faqs": [
    {
      "id": "custom_2bc6bb6c-e009-4a7a-a50b-3ea07a78cf79",
      "question": "Is Central Station on Orange pet-friendly?",
      "answer": "Yes. Central Station on Orange welcomes cats and dogs, up to 2 pets per home, with no posted weight limit. Some breed restrictions apply. Assistance animals (service animals and emotional support animals) are not pets under fair housing law, so they are not subject to pet fees, deposits, or breed and weight restrictions. For the full pet policy, call the leasing team at (407) 254-0045 or visit our contact page.",
      "category": "Pet Policy",
      "source": "custom"
    },
    {
      "id": "custom_120159d5-0917-4347-a18a-5e3b2b521b22",
      "question": "How can I schedule a tour at Central Station on Orange?",
      "answer": "You can schedule a tour of Central Station on Orange online through our Schedule a Tour page, or call the leasing office at (407) 254-0045. You can also view our virtual tours to see the community before visiting in person.",
      "category": "Contact & Tours",
      "source": "custom"
    },
    {
      "id": "custom_33f7749b-fafb-4132-b380-9dd576b69330",
      "question": "What are the leasing office hours at Central Station on Orange?",
      "answer": "The Central Station on Orange leasing office is open during these hours:\n\n• Monday: 9:00 AM to 6:00 PM\n• Tuesday: 9:00 AM to 6:00 PM\n• Wednesday: 9:00 AM to 6:00 PM\n• Thursday: 9:00 AM to 6:00 PM\n• Friday: 9:00 AM to 6:00 PM\n• Saturday: 10:00 AM to 5:00 PM\n\nHours may change around holidays. Call (407) 254-0045 or visit our contact page to confirm before you visit.",
      "category": "Office Hours",
      "source": "custom"
    },
    {
      "id": "custom_ffd5c639-eb94-4a80-8979-495cc6fbba8b",
      "question": "What floor plans are available at Central Station on Orange?",
      "answer": "Central Station on Orange offers 1- to 3-bedroom apartment homes ranging from approximately 532 to 1,641 square feet, across 26 floor plans. View layouts, square footage, and current availability on our Floor Plans page, or schedule a tour to see them in person.",
      "category": "Floor Plans & Units",
      "source": "custom"
    },
    {
      "id": "custom_442b49fa-3a21-4515-bef1-0da94dbda8d9",
      "question": "What amenities does Central Station on Orange have?",
      "answer": "Central Station on Orange offers a range of community and in-home amenities. Community amenities include: Pool, Two‑Story Fitness & Health Center, Strength, Spin Bikes, Cardio Equipment & Virtual Training Studio, Expansive Rooftop Deck w/ Downtown Orlando Views, Strength & Cardio Center w/ Spin & Virtual Training, NGBS Green Registered, Private Pet Park & Posh Spa, Electric‑Vehicle Charging Station, Club Room w/ Full Demonstration Kitchen, Specialty Coffee Bar & TV Lounge for Social Events, Credit Building Services Powered by RentPlus, Concierge Cleaning Services Available by Spruce, Convenient 24/7 Online Resident Services, and American Landmark 360 Resident Program. In-home features include: ge stainless‑steel energy star qualified appliances, gourmet style kitchens, sleek granite countertops, contemporary tile backsplash, in‑home washer & dryer, 42\" cabinetry w/ under cabinet lighting, modern satin hardware, lighting and fixtures, 9' ceilings, wood‑style plank flooring, usb ports, and spacious walk‑in closets. See the complete list on our Amenities page.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_ee36558c-07a3-46c8-ad62-a929a39a2873",
      "question": "Where is Central Station on Orange located?",
      "answer": "Central Station on Orange is located at 480 N Orange Ave, Orlando FL 32801. Nearby you'll find dining at Kres Chophouse, shopping at Publix Super Market at The Paramount on Lake Eola, and green space at Lake Eola Park. Explore more on our Neighborhood page.",
      "category": "Location & Neighborhood",
      "source": "custom"
    },
    {
      "id": "custom_84b084e0-e288-4034-8e74-2a9feb833882",
      "question": "How do I apply to live at Central Station on Orange?",
      "answer": "You can apply to live at Central Station on Orange online through our Apply Now page, which walks you through each step. If you have questions, the leasing team can help. Call (407) 254-0045 or reach out through our contact page.",
      "category": "Application Process",
      "source": "custom"
    },
    {
      "id": "custom_65259006-762e-486e-a4fa-0c47b43d0852",
      "question": "What do I need to apply at Central Station on Orange?",
      "answer": "Applicants should be ready to provide standard rental application information, including government-issued identification, proof of income, and rental history. Qualification requirements can vary, so we recommend confirming the current criteria with the Central Station on Orange leasing team at (407) 254-0045 or on our contact page. When you're ready, start on the Apply Now page.",
      "category": "Application Process",
      "source": "custom"
    },
    {
      "id": "custom_62b201c4-ff40-4a72-84d8-0f656d58fb91",
      "question": "What is the Landmark 360 program at Central Station on Orange?",
      "answer": "Central Station on Orange participates in American Landmark's Landmark 360 resident program, which includes three resident promises:\n\n• Move-In Satisfaction Promise: if you are not satisfied within your first 15 days, American Landmark will refund your deposit and waive lease-termination fees.\n• 48-Hour Maintenance Completion Promise: work orders are completed within 48 hours (Monday through Friday), with rent credits if that timeline is missed.\n• Relocation Promise: after six months on your lease, you can transfer to another American Landmark community without penalties, with 60 days' written notice.\nTo learn more, contact the leasing team at (407) 254-0045 or visit our contact page.",
      "category": "Resident Programs",
      "source": "custom"
    },
    {
      "id": "custom_86715277-3271-4ce9-9ca6-5a7dc4a65262",
      "question": "Does Central Station on Orange have a pool?",
      "answer": "Yes. Central Station on Orange has a swimming pool for residents. See it alongside our other community amenities on the Amenities page.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_409a12ec-5549-490d-8625-d7de6af879b0",
      "question": "Does Central Station on Orange have a fitness center?",
      "answer": "Yes. Central Station on Orange has a 24-hour fitness center available to residents at any time. See all amenities on the Amenities page, or schedule a tour to view it in person.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_bbe9f6e0-3729-4585-b7a7-76425c641f68",
      "question": "Does Central Station on Orange offer virtual tours?",
      "answer": "Yes. Central Station on Orange offers virtual tours of Central Station on Orange - Community Tour. Start on our Virtual Tours page, then schedule an in-person tour when you are ready.",
      "category": "Contact & Tours",
      "source": "custom"
    },
    {
      "id": "custom_f4cbee5e-49eb-4018-a3d2-df838ddadcf8",
      "question": "What do residents say about living at Central Station on Orange?",
      "answer": "Residents frequently mention the helpful staff and responsive maintenance at Central Station on Orange. One resident wrote: *\"I love the tranquility, as well as the people that are in the building. Love the modern feel, eco, the area, the prompt maintenance staff & the courteousness of Everton in the building.\"* Read more resident reviews on our Reviews page.",
      "category": "Resident Life",
      "source": "custom"
    },
    {
      "id": "custom_a86c8fd2-e5c3-4918-b9df-09bcef34184c",
      "question": "When was Central Station on Orange built?",
      "answer": "Central Station on Orange was built in 2015 and renovated in 2022. Schedule a tour to see the finishes in person.",
      "category": "Property History & Features",
      "source": "custom"
    },
    {
      "id": "custom_613e61f3-15de-4e19-91fc-249170bdc8d0",
      "question": "What is the pet fee at Central Station on Orange?",
      "answer": "Pets at Central Station on Orange: cats and dogs are welcome, up to 2 per home, with no posted weight limit. Some breed restrictions apply. Assistance animals (service animals and emotional support animals) are not pets under fair housing law, so they are not subject to pet fees, deposits, or breed and weight restrictions. For details, contact the leasing team at (407) 254-0045 or visit our contact page.",
      "category": "Pet Policy",
      "source": "custom"
    },
    {
      "id": "custom_ce82e90c-571c-4d41-8045-cd6a43e55593",
      "question": "What features are included in the apartments at Central Station on Orange?",
      "answer": "Apartment homes at Central Station on Orange include ge stainless‑steel energy star qualified appliances, gourmet style kitchens, sleek granite countertops, contemporary tile backsplash, in‑home washer & dryer, 42\" cabinetry w/ under cabinet lighting, modern satin hardware, lighting and fixtures, 9' ceilings, wood‑style plank flooring, usb ports, and spacious walk‑in closets. Browse layouts on our Floor Plans page or schedule a tour.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_5a20d038-3865-4492-ab75-824161401335",
      "question": "What restaurants and shops are near Central Station on Orange?",
      "answer": "Nearby restaurants and shops include Kres Chophouse, The Boheme, The Stubborn Mule, and JINYA Ramen Bar - Thornton Park. See the full neighborhood guide on our Neighborhood page.",
      "category": "Location & Neighborhood",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa45-49b5-740d-9abc-861c3d07c01b",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "central-station-on-orange",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072"
    },
    {
      "lead_collector_id": "0198aa45-4a18-70de-9ee1-901014380948",
      "lead_source": "FACEBOOK_ADS",
      "name": "central-station-on-orange",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072"
    },
    {
      "lead_collector_id": "0198aa45-4a7d-7077-90c8-2bb2e9419afd",
      "lead_source": "LANDING_PAGE",
      "name": "central-station-on-orange",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "custom",
      "page_item_url": "studio-apartments-for-rent-orlando-central-station-orange",
      "search_query": "Studio Apartments For Rent In Orlando FL",
      "category": "Floorplan",
      "h1_title": "Studio Apartments For Rent In Orlando FL at Central Station on Orange",
      "h2_subtitle": "Discover the perfect blend of urban living and modern amenities. Our studio apartments offer everything you need for a comfortable lifestyle in Downtown Orlando.",
      "page_copy": "At Central Station on Orange, our studio apartments for rent in Orlando FL are designed to keep you connected to the vibrant city life. Located in Downtown Orlando, near Lake Eola, our community features a tech lounge, a two-story fitness center, and a rooftop lounge with stunning skyline views. Whether you prefer to walk, bike, or use public transportation, getting around is a breeze with LYMMO and SunRail nearby. \n\nEach studio apartment features GE stainless-steel Energy Star qualified appliances, gourmet style kitchens with sleek granite countertops, and contemporary tile backsplashes. Enjoy the convenience of in-home washers and dryers, spacious walk-in closets, and modern satin hardware. With 9' ceilings and wood-style plank flooring, our apartments provide a stylish and comfortable living space. Come home to Central Station on Orange, where your stop is here.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f6c0d-556d-7560-8f12-04f4192848b3.webp",
      "featured_image_media": {
        "alt_text": "Living room and bedroom view of a modern apartment with elegant furniture and balcony access.",
        "public_id": "019f6c0d-556d-7560-8f12-04f4192848b3",
        "storage_key": "property/5697443643523072/019f6c0d-556d-7560-8f12-04f4192848b3.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f6c0d-6019-7095-89f6-416138ff5ff7.webp",
      "blank_image_media": {
        "alt_text": "Exterior of the apartment building",
        "public_id": "019f6c0d-6019-7095-89f6-416138ff5ff7",
        "storage_key": "property/5697443643523072/019f6c0d-6019-7095-89f6-416138ff5ff7.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Central Station on Orange | Studio Apartments For Rent In Orlando FL",
      "seo_description": "Find studio apartments for rent in Orlando FL at Central Station on Orange. Enjoy modern amenities and urban living in Downtown Orlando. Your stop is here.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-rent-orlando-central-station",
      "search_query": "One Bedroom Apartments For Rent In Orlando FL",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments For Rent In Orlando FL at Central Station on Orange",
      "h2_subtitle": "Experience the best of urban living with our one-bedroom apartments. Enjoy modern amenities and a prime location in Downtown Orlando, near Lake Eola.",
      "page_copy": "Central Station on Orange offers one bedroom apartments for rent in Orlando FL that are perfect for modern city living. Situated in Downtown Orlando, near Lake Eola, our community provides easy access to the vibrant urban landscape. Enjoy the convenience of our tech lounge, two-story fitness center, and rooftop lounge with breathtaking views of the Orlando skyline. With LYMMO and SunRail nearby, commuting is effortless whether you walk, bike, or use public transportation. \n\nOur one-bedroom apartments feature GE stainless-steel Energy Star qualified appliances, gourmet style kitchens with sleek granite countertops, and contemporary tile backsplashes. Each unit includes in-home washers and dryers, spacious walk-in closets, and modern satin hardware. With 9' ceilings and wood-style plank flooring, our apartments offer a stylish and comfortable living environment. Discover your new home at Central Station on Orange, where your stop is here.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f6c0d-556d-7560-8f12-04f4192848b3.webp",
      "featured_image_media": {
        "alt_text": "Living room and bedroom view of a modern apartment with elegant furniture and balcony access.",
        "public_id": "019f6c0d-556d-7560-8f12-04f4192848b3",
        "storage_key": "property/5697443643523072/019f6c0d-556d-7560-8f12-04f4192848b3.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f6c0d-6019-7095-89f6-416138ff5ff7.webp",
      "blank_image_media": {
        "alt_text": "Exterior of the apartment building",
        "public_id": "019f6c0d-6019-7095-89f6-416138ff5ff7",
        "storage_key": "property/5697443643523072/019f6c0d-6019-7095-89f6-416138ff5ff7.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Central Station on Orange | One Bedroom Apartments For Rent In Orlando FL",
      "seo_description": "Explore one bedroom apartments for rent in Orlando FL at Central Station on Orange. Enjoy modern amenities and urban living in Downtown Orlando. Your stop is here.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "custom",
      "page_item_url": "two-bedrooms-apartments-for-rent-in-orlando-fl",
      "search_query": "Two Bedrooms Apartments For Rent In Orlando FL",
      "category": "Floorplan",
      "h1_title": "Two Bedrooms Apartments For Rent In Orlando FL at Central Station on Orange",
      "h2_subtitle": "Upgrade your lifestyle with our spacious two-bedroom apartments. Enjoy modern amenities and a prime Downtown Orlando location near Lake Eola.",
      "page_copy": "Discover the perfect two bedrooms apartments for rent in Orlando FL at Central Station on Orange. Located in the heart of Downtown Orlando, near Lake Eola, our community offers a vibrant urban living experience. Take advantage of our tech lounge, two-story fitness center, and rooftop lounge with stunning views of the Orlando skyline. With LYMMO and SunRail nearby, commuting is a breeze whether you walk, bike, or use public transportation. \n\nOur two-bedroom apartments feature GE stainless-steel Energy Star qualified appliances, gourmet style kitchens with sleek granite countertops, and contemporary tile backsplashes. Each unit includes in-home washers and dryers, spacious walk-in closets, and modern satin hardware. With 9' ceilings and wood-style plank flooring, our apartments provide a stylish and comfortable living space. Make Central Station on Orange your new home, where your stop is here.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f6c0d-556d-7560-8f12-04f4192848b3.webp",
      "featured_image_media": {
        "alt_text": "Living room and bedroom view of a modern apartment with elegant furniture and balcony access.",
        "public_id": "019f6c0d-556d-7560-8f12-04f4192848b3",
        "storage_key": "property/5697443643523072/019f6c0d-556d-7560-8f12-04f4192848b3.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f6c0d-6019-7095-89f6-416138ff5ff7.webp",
      "blank_image_media": {
        "alt_text": "Exterior of the apartment building",
        "public_id": "019f6c0d-6019-7095-89f6-416138ff5ff7",
        "storage_key": "property/5697443643523072/019f6c0d-6019-7095-89f6-416138ff5ff7.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Central Station on Orange | Two Bedrooms Apartments For Rent In Orlando FL",
      "seo_description": "Find two bedrooms apartments for rent in Orlando FL at Central Station on Orange. Enjoy modern amenities and urban living in Downtown Orlando. Your stop is here.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "custom",
      "page_item_url": "three-bedrooms-apartments-for-rent-in-orlando-fl",
      "search_query": "Three Bedrooms Apartments For Rent In Orlando FL",
      "category": "Floorplan",
      "h1_title": "Three Bedrooms Apartments For Rent In Orlando FL at Central Station on Orange",
      "h2_subtitle": "Experience spacious living with our three-bedroom apartments. Enjoy modern amenities and a prime Downtown Orlando location near Lake Eola.",
      "page_copy": "Central Station on Orange offers three bedrooms apartments for rent in Orlando FL that are perfect for families or roommates seeking a spacious urban living experience. Located in Downtown Orlando, near Lake Eola, our community provides easy access to the vibrant city life. Enjoy the convenience of our tech lounge, two-story fitness center, and rooftop lounge with breathtaking views of the Orlando skyline. With LYMMO and SunRail nearby, commuting is effortless whether you walk, bike, or use public transportation. \n\nOur three-bedroom apartments feature GE stainless-steel Energy Star qualified appliances, gourmet style kitchens with sleek granite countertops, and contemporary tile backsplashes. Each unit includes in-home washers and dryers, spacious walk-in closets, and modern satin hardware. With 9' ceilings and wood-style plank flooring, our apartments offer a stylish and comfortable living environment. Discover your new home at Central Station on Orange, where your stop is here.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f6c0d-556d-7560-8f12-04f4192848b3.webp",
      "featured_image_media": {
        "alt_text": "Living room and bedroom view of a modern apartment with elegant furniture and balcony access.",
        "public_id": "019f6c0d-556d-7560-8f12-04f4192848b3",
        "storage_key": "property/5697443643523072/019f6c0d-556d-7560-8f12-04f4192848b3.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f6c0d-6019-7095-89f6-416138ff5ff7.webp",
      "blank_image_media": {
        "alt_text": "Exterior of the apartment building",
        "public_id": "019f6c0d-6019-7095-89f6-416138ff5ff7",
        "storage_key": "property/5697443643523072/019f6c0d-6019-7095-89f6-416138ff5ff7.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Central Station on Orange | Three Bedrooms Apartments For Rent In Orlando FL",
      "seo_description": "Explore three bedrooms apartments for rent in Orlando FL at Central Station on Orange. Enjoy modern amenities and urban living in Downtown Orlando. Your stop is here.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-resort-style-pool",
      "search_query": "Apartments For Rent Near Me with Resort-Style Pool",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Resort-Style Pool at Central Station on Orange",
      "h2_subtitle": "Enjoy luxury living with our resort-style pool and modern amenities. Located in Downtown Orlando, our apartments offer the perfect blend of comfort and convenience.",
      "page_copy": "Discover the ultimate in luxury living with apartments for rent near me with resort-style pool at Central Station on Orange. Located in Downtown Orlando, near Lake Eola, our community offers a vibrant urban lifestyle with top-notch amenities. Take a dip in our resort-style pool, stay fit at our two-story fitness center, or relax on the expansive rooftop deck with stunning views of Downtown Orlando. With LYMMO and SunRail nearby, commuting is a breeze whether you walk, bike, or use public transportation. \n\nOur apartments feature GE stainless-steel Energy Star qualified appliances, gourmet style kitchens with sleek granite countertops, and contemporary tile backsplashes. Each unit includes in-home washers and dryers, spacious walk-in closets, and modern satin hardware. With 9' ceilings and wood-style plank flooring, our apartments provide a stylish and comfortable living space. Come home to Central Station on Orange, where your stop is here.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f6c0d-556d-7560-8f12-04f4192848b3.webp",
      "featured_image_media": {
        "alt_text": "Living room and bedroom view of a modern apartment with elegant furniture and balcony access.",
        "public_id": "019f6c0d-556d-7560-8f12-04f4192848b3",
        "storage_key": "property/5697443643523072/019f6c0d-556d-7560-8f12-04f4192848b3.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f6c0d-6019-7095-89f6-416138ff5ff7.webp",
      "blank_image_media": {
        "alt_text": "Exterior of the apartment building",
        "public_id": "019f6c0d-6019-7095-89f6-416138ff5ff7",
        "storage_key": "property/5697443643523072/019f6c0d-6019-7095-89f6-416138ff5ff7.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Central Station on Orange | Apartments For Rent Near Me with Resort-Style Pool",
      "seo_description": "Find apartments for rent near me with resort-style pool at Central Station on Orange. Enjoy luxury living and modern amenities in Downtown Orlando. Your stop is here.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-two-story-fitness-health-center",
      "search_query": "Apartments For Rent Near Me with Two-Story Fitness & Health Center",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Two-Story Fitness & Health Center at Central Station on Orange",
      "h2_subtitle": "Elevate your lifestyle with our two-story fitness and health center. Located in Downtown Orlando, our apartments offer modern amenities and urban convenience.",
      "page_copy": "Discover the perfect apartments for rent near me with two-story fitness & health center at Central Station on Orange. Located in the heart of Downtown Orlando, near Lake Eola, our community offers a vibrant urban living experience with top-tier amenities. Stay active and healthy with our state-of-the-art two-story fitness center, featuring strength, spin bikes, cardio equipment, and a virtual training studio. Enjoy the convenience of LYMMO and SunRail nearby, making commuting a breeze whether you walk, bike, or use public transportation. \n\nOur apartments feature GE stainless-steel Energy Star qualified appliances, gourmet style kitchens with sleek granite countertops, and contemporary tile backsplashes. Each unit includes in-home washers and dryers, spacious walk-in closets, and modern satin hardware. With 9' ceilings and wood-style plank flooring, our apartments provide a stylish and comfortable living space. Come home to Central Station on Orange, where your stop is here.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f6c0d-556d-7560-8f12-04f4192848b3.webp",
      "featured_image_media": {
        "alt_text": "Living room and bedroom view of a modern apartment with elegant furniture and balcony access.",
        "public_id": "019f6c0d-556d-7560-8f12-04f4192848b3",
        "storage_key": "property/5697443643523072/019f6c0d-556d-7560-8f12-04f4192848b3.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f6c0d-6019-7095-89f6-416138ff5ff7.webp",
      "blank_image_media": {
        "alt_text": "Exterior of the apartment building",
        "public_id": "019f6c0d-6019-7095-89f6-416138ff5ff7",
        "storage_key": "property/5697443643523072/019f6c0d-6019-7095-89f6-416138ff5ff7.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Central Station on Orange | Apartments For Rent Near Me with Two-Story Fitness & Health Center",
      "seo_description": "Find apartments for rent near me with two-story fitness & health center at Central Station on Orange. Enjoy modern amenities and urban living in Downtown Orlando. Your stop is here.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-rooftop-deck-orlando",
      "search_query": "Apartments For Rent Near Me with Expansive Rooftop Deck w/ Downtown Orlando Views",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Expansive Rooftop Deck w/ Downtown Orlando Views at Central Station on Orange",
      "h2_subtitle": "Experience breathtaking views from our expansive rooftop deck. Located in Downtown Orlando, our apartments offer modern living and unparalleled convenience.",
      "page_copy": "Discover the ideal apartments for rent near me with expansive rooftop deck w/ Downtown Orlando views at Central Station on Orange. Located in the vibrant Downtown Orlando, near Lake Eola, our community offers a dynamic urban lifestyle with top-notch amenities. Enjoy stunning views of the Orlando skyline from our expansive rooftop deck, perfect for relaxing or socializing. With LYMMO and SunRail nearby, commuting is effortless whether you walk, bike, or use public transportation. \n\nOur apartments feature GE stainless-steel Energy Star qualified appliances, gourmet style kitchens with sleek granite countertops, and contemporary tile backsplashes. Each unit includes in-home washers and dryers, spacious walk-in closets, and modern satin hardware. With 9' ceilings and wood-style plank flooring, our apartments provide a stylish and comfortable living space. Come home to Central Station on Orange, where your stop is here.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f6c0d-556d-7560-8f12-04f4192848b3.webp",
      "featured_image_media": {
        "alt_text": "Living room and bedroom view of a modern apartment with elegant furniture and balcony access.",
        "public_id": "019f6c0d-556d-7560-8f12-04f4192848b3",
        "storage_key": "property/5697443643523072/019f6c0d-556d-7560-8f12-04f4192848b3.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f6c0d-6019-7095-89f6-416138ff5ff7.webp",
      "blank_image_media": {
        "alt_text": "Exterior of the apartment building",
        "public_id": "019f6c0d-6019-7095-89f6-416138ff5ff7",
        "storage_key": "property/5697443643523072/019f6c0d-6019-7095-89f6-416138ff5ff7.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Central Station on Orange | Apartments For Rent Near Me with Expansive Rooftop Deck w/ Downtown Orlando Views",
      "seo_description": "Find apartments for rent near me with expansive rooftop deck w/ Downtown Orlando views at Central Station on Orange. Enjoy modern amenities and urban living in Downtown Orlando. Your stop is here.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "custom",
      "page_item_url": "apartments-for-rent-in-orlando-near-adventhealth",
      "search_query": "Apartments For Rent In Orlando FL Near AdventHealth Orlando",
      "category": "POI",
      "h1_title": "Apartments For Rent In Orlando FL Near AdventHealth Orlando at Central Station on Orange",
      "h2_subtitle": "Enjoy modern living close to AdventHealth Orlando. Our apartments offer top-tier amenities and a prime Downtown Orlando location near Lake Eola.",
      "page_copy": "Discover the ideal apartments for rent in Orlando FL near AdventHealth Orlando at Central Station on Orange. Located in the vibrant Downtown Orlando, near Lake Eola, our community offers a dynamic urban lifestyle with top-notch amenities. Enjoy the convenience of being close to AdventHealth Orlando while taking advantage of our resort-style pool, two-story fitness center, and expansive rooftop deck with stunning views of the Orlando skyline. With LYMMO and SunRail nearby, commuting is effortless whether you walk, bike, or use public transportation. \n\nOur apartments feature GE stainless-steel Energy Star qualified appliances, gourmet style kitchens with sleek granite countertops, and contemporary tile backsplashes. Each unit includes in-home washers and dryers, spacious walk-in closets, and modern satin hardware. With 9' ceilings and wood-style plank flooring, our apartments provide a stylish and comfortable living space. Come home to Central Station on Orange, where your stop is here.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f6c0d-556d-7560-8f12-04f4192848b3.webp",
      "featured_image_media": {
        "alt_text": "Living room and bedroom view of a modern apartment with elegant furniture and balcony access.",
        "public_id": "019f6c0d-556d-7560-8f12-04f4192848b3",
        "storage_key": "property/5697443643523072/019f6c0d-556d-7560-8f12-04f4192848b3.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f6c0d-6019-7095-89f6-416138ff5ff7.webp",
      "blank_image_media": {
        "alt_text": "Exterior of the apartment building",
        "public_id": "019f6c0d-6019-7095-89f6-416138ff5ff7",
        "storage_key": "property/5697443643523072/019f6c0d-6019-7095-89f6-416138ff5ff7.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Central Station on Orange | Apartments For Rent In Orlando FL Near AdventHealth Orlando",
      "seo_description": "Find apartments for rent in Orlando FL near AdventHealth Orlando at Central Station on Orange. Enjoy modern amenities and urban living in Downtown Orlando. Your stop is here.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-adventhealth-east-orlando",
      "search_query": "Apartments For Rent In Orlando FL Near AdventHealth East Orlando",
      "category": "POI",
      "h1_title": "Apartments For Rent In Orlando FL Near AdventHealth East Orlando at Central Station on Orange",
      "h2_subtitle": "Live close to exceptional care at AdventHealth East Orlando. Our apartments offer modern amenities and a prime Downtown Orlando location near Lake Eola.",
      "page_copy": "Discover the perfect apartments for rent in Orlando FL near AdventHealth East Orlando at Central Station on Orange. Located in the vibrant Downtown Orlando, near Lake Eola, our community offers a dynamic urban lifestyle with top-notch amenities. Enjoy the convenience of being close to AdventHealth East Orlando, where exceptional care is provided to your family and the community. Take advantage of our resort-style pool, two-story fitness center, and expansive rooftop deck with stunning views of the Orlando skyline. With LYMMO and SunRail nearby, commuting is effortless whether you walk, bike, or use public transportation. \n\nOur apartments feature GE stainless-steel Energy Star qualified appliances, gourmet style kitchens with sleek granite countertops, and contemporary tile backsplashes. Each unit includes in-home washers and dryers, spacious walk-in closets, and modern satin hardware. With 9' ceilings and wood-style plank flooring, our apartments provide a stylish and comfortable living space. Come home to Central Station on Orange, where your stop is here.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f6c0d-556d-7560-8f12-04f4192848b3.webp",
      "featured_image_media": {
        "alt_text": "Living room and bedroom view of a modern apartment with elegant furniture and balcony access.",
        "public_id": "019f6c0d-556d-7560-8f12-04f4192848b3",
        "storage_key": "property/5697443643523072/019f6c0d-556d-7560-8f12-04f4192848b3.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f6c0d-6019-7095-89f6-416138ff5ff7.webp",
      "blank_image_media": {
        "alt_text": "Exterior of the apartment building",
        "public_id": "019f6c0d-6019-7095-89f6-416138ff5ff7",
        "storage_key": "property/5697443643523072/019f6c0d-6019-7095-89f6-416138ff5ff7.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Central Station on Orange | Apartments For Rent In Orlando FL Near AdventHealth East Orlando",
      "seo_description": "Find apartments for rent in Orlando FL near AdventHealth East Orlando at Central Station on Orange. Enjoy modern amenities and urban living in Downtown Orlando. Your stop is here.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "custom",
      "page_item_url": "apartments-for-rent-orlando-fl-near-adventhealth",
      "search_query": "Apartments For Rent In Orlando FL Near AdventHealth Winter Park",
      "category": "POI",
      "h1_title": "Apartments For Rent In Orlando FL Near AdventHealth Winter Park at Central Station on Orange",
      "h2_subtitle": "Live close to exceptional care at AdventHealth Winter Park. Our apartments offer modern amenities and a prime Downtown Orlando location near Lake Eola.",
      "page_copy": "Discover the perfect apartments for rent in Orlando FL near AdventHealth Winter Park at Central Station on Orange. Located in the vibrant Downtown Orlando, near Lake Eola, our community offers a dynamic urban lifestyle with top-notch amenities. Enjoy the convenience of being close to AdventHealth Winter Park, where exceptional care is provided to your family and the community. Take advantage of our resort-style pool, two-story fitness center, and expansive rooftop deck with stunning views of the Orlando skyline. With LYMMO and SunRail nearby, commuting is effortless whether you walk, bike, or use public transportation. \n\nOur apartments feature GE stainless-steel Energy Star qualified appliances, gourmet style kitchens with sleek granite countertops, and contemporary tile backsplashes. Each unit includes in-home washers and dryers, spacious walk-in closets, and modern satin hardware. With 9' ceilings and wood-style plank flooring, our apartments provide a stylish and comfortable living space. Come home to Central Station on Orange, where your stop is here.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f6c0d-556d-7560-8f12-04f4192848b3.webp",
      "featured_image_media": {
        "alt_text": "Living room and bedroom view of a modern apartment with elegant furniture and balcony access.",
        "public_id": "019f6c0d-556d-7560-8f12-04f4192848b3",
        "storage_key": "property/5697443643523072/019f6c0d-556d-7560-8f12-04f4192848b3.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f6c0d-6019-7095-89f6-416138ff5ff7.webp",
      "blank_image_media": {
        "alt_text": "Exterior of the apartment building",
        "public_id": "019f6c0d-6019-7095-89f6-416138ff5ff7",
        "storage_key": "property/5697443643523072/019f6c0d-6019-7095-89f6-416138ff5ff7.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Central Station on Orange | Apartments For Rent In Orlando FL Near AdventHealth Winter Park",
      "seo_description": "Find apartments for rent in Orlando FL near AdventHealth Winter Park at Central Station on Orange. Enjoy modern amenities and urban living in Downtown Orlando. Your stop is here.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "custom",
      "page_item_url": "apartments-for-rent-orlando-fl-near-adventhealth-medical",
      "search_query": "Apartments For Rent In Orlando FL Near AdventHealth Medical Group Pediatric Orthopedic Surgery at Orlando",
      "category": "POI",
      "h1_title": "Apartments For Rent In Orlando FL Near AdventHealth Medical Group Pediatric Orthopedic Surgery at Orlando at Central Station on Orange",
      "h2_subtitle": "Live close to exceptional pediatric orthopedic care. Our apartments offer modern amenities and a prime Downtown Orlando location near Lake Eola.",
      "page_copy": "Discover the perfect apartments for rent in Orlando FL near AdventHealth Medical Group Pediatric Orthopedic Surgery at Orlando at Central Station on Orange. Located in the vibrant Downtown Orlando, near Lake Eola, our community offers a dynamic urban lifestyle with top-notch amenities. Enjoy the convenience of being close to AdventHealth Medical Group Pediatric Orthopedic Surgery, where compassionate and collaborative care is provided to your family. Take advantage of our resort-style pool, two-story fitness center, and expansive rooftop deck with stunning views of the Orlando skyline. With LYMMO and SunRail nearby, commuting is effortless whether you walk, bike, or use public transportation. \n\nOur apartments feature GE stainless-steel Energy Star qualified appliances, gourmet style kitchens with sleek granite countertops, and contemporary tile backsplashes. Each unit includes in-home washers and dryers, spacious walk-in closets, and modern satin hardware. With 9' ceilings and wood-style plank flooring, our apartments provide a stylish and comfortable living space. Come home to Central Station on Orange, where your stop is here.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f6c0d-556d-7560-8f12-04f4192848b3.webp",
      "featured_image_media": {
        "alt_text": "Living room and bedroom view of a modern apartment with elegant furniture and balcony access.",
        "public_id": "019f6c0d-556d-7560-8f12-04f4192848b3",
        "storage_key": "property/5697443643523072/019f6c0d-556d-7560-8f12-04f4192848b3.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f6c0d-6019-7095-89f6-416138ff5ff7.webp",
      "blank_image_media": {
        "alt_text": "Exterior of the apartment building",
        "public_id": "019f6c0d-6019-7095-89f6-416138ff5ff7",
        "storage_key": "property/5697443643523072/019f6c0d-6019-7095-89f6-416138ff5ff7.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Central Station on Orange | Apartments For Rent In Orlando FL Near AdventHealth Medical Group Pediatric Orthopedic Surgery at Orlando",
      "seo_description": "Find apartments for rent in Orlando FL near AdventHealth Medical Group Pediatric Orthopedic Surgery at Orlando at Central Station on Orange. Enjoy modern amenities and urban living in Downtown Orlando. Your stop is here.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-universal-technical-institute",
      "search_query": "Apartments For Rent In Orlando FL Near Universal Technical Institute",
      "category": "POI",
      "h1_title": "Apartments For Rent In Orlando FL Near Universal Technical Institute at Central Station on Orange",
      "h2_subtitle": "Live close to Universal Technical Institute with our modern apartments. Enjoy top-tier amenities and a prime Downtown Orlando location near Lake Eola.",
      "page_copy": "Discover the perfect apartments for rent in Orlando FL near Universal Technical Institute at Central Station on Orange. Located in the vibrant Downtown Orlando, near Lake Eola, our community offers a dynamic urban lifestyle with top-notch amenities. Enjoy the convenience of being close to Universal Technical Institute while taking advantage of our resort-style pool, two-story fitness center, and expansive rooftop deck with stunning views of the Orlando skyline. With LYMMO and SunRail nearby, commuting is effortless whether you walk, bike, or use public transportation. \n\nOur apartments feature GE stainless-steel Energy Star qualified appliances, gourmet style kitchens with sleek granite countertops, and contemporary tile backsplashes. Each unit includes in-home washers and dryers, spacious walk-in closets, and modern satin hardware. With 9' ceilings and wood-style plank flooring, our apartments provide a stylish and comfortable living space. Come home to Central Station on Orange, where your stop is here.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f6c0d-556d-7560-8f12-04f4192848b3.webp",
      "featured_image_media": {
        "alt_text": "Living room and bedroom view of a modern apartment with elegant furniture and balcony access.",
        "public_id": "019f6c0d-556d-7560-8f12-04f4192848b3",
        "storage_key": "property/5697443643523072/019f6c0d-556d-7560-8f12-04f4192848b3.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f6c0d-6019-7095-89f6-416138ff5ff7.webp",
      "blank_image_media": {
        "alt_text": "Exterior of the apartment building",
        "public_id": "019f6c0d-6019-7095-89f6-416138ff5ff7",
        "storage_key": "property/5697443643523072/019f6c0d-6019-7095-89f6-416138ff5ff7.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Central Station on Orange | Apartments For Rent In Orlando FL Near Universal Technical Institute",
      "seo_description": "Find apartments for rent in Orlando FL near Universal Technical Institute at Central Station on Orange. Enjoy modern amenities and urban living in Downtown Orlando. Your stop is here.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-valencia-college-east-campus",
      "search_query": "Apartments For Rent In Orlando FL Near Valencia College East Campus Library",
      "category": "POI",
      "h1_title": "Apartments For Rent In Orlando FL Near Valencia College East Campus Library at Central Station on Orange",
      "h2_subtitle": "Live close to Valencia College East Campus Library with our modern apartments. Enjoy top-tier amenities and a prime Downtown Orlando location near Lake Eola.",
      "page_copy": "Discover the perfect apartments for rent in Orlando FL near Valencia College East Campus Library at Central Station on Orange. Located in the vibrant Downtown Orlando, near Lake Eola, our community offers a dynamic urban lifestyle with top-notch amenities. Enjoy the convenience of being close to Valencia College East Campus Library while taking advantage of our resort-style pool, two-story fitness center, and expansive rooftop deck with stunning views of the Orlando skyline. With LYMMO and SunRail nearby, commuting is effortless whether you walk, bike, or use public transportation. \n\nOur apartments feature GE stainless-steel Energy Star qualified appliances, gourmet style kitchens with sleek granite countertops, and contemporary tile backsplashes. Each unit includes in-home washers and dryers, spacious walk-in closets, and modern satin hardware. With 9' ceilings and wood-style plank flooring, our apartments provide a stylish and comfortable living space. Come home to Central Station on Orange, where your stop is here.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f6c0d-556d-7560-8f12-04f4192848b3.webp",
      "featured_image_media": {
        "alt_text": "Living room and bedroom view of a modern apartment with elegant furniture and balcony access.",
        "public_id": "019f6c0d-556d-7560-8f12-04f4192848b3",
        "storage_key": "property/5697443643523072/019f6c0d-556d-7560-8f12-04f4192848b3.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f6c0d-6019-7095-89f6-416138ff5ff7.webp",
      "blank_image_media": {
        "alt_text": "Exterior of the apartment building",
        "public_id": "019f6c0d-6019-7095-89f6-416138ff5ff7",
        "storage_key": "property/5697443643523072/019f6c0d-6019-7095-89f6-416138ff5ff7.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Central Station on Orange | Apartments For Rent In Orlando FL Near Valencia College East Campus Library",
      "seo_description": "Find apartments for rent in Orlando FL near Valencia College East Campus Library at Central Station on Orange. Enjoy modern amenities and urban living in Downtown Orlando. Your stop is here.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "custom",
      "page_item_url": "apartments-for-rent-orlando-fl-near-everest-university",
      "search_query": "Apartments For Rent In Orlando FL Near Everest University North Orlando",
      "category": "POI",
      "h1_title": "Apartments For Rent In Orlando FL Near Everest University North Orlando at Central Station on Orange",
      "h2_subtitle": "Live close to Everest University North Orlando with our modern apartments. Enjoy top-tier amenities and a prime Downtown Orlando location near Lake Eola.",
      "page_copy": "Discover the perfect apartments for rent in Orlando FL near Everest University North Orlando at Central Station on Orange. Located in the vibrant Downtown Orlando, near Lake Eola, our community offers a dynamic urban lifestyle with top-notch amenities. Enjoy the convenience of being close to Everest University North Orlando while taking advantage of our resort-style pool, two-story fitness center, and expansive rooftop deck with stunning views of the Orlando skyline. With LYMMO and SunRail nearby, commuting is effortless whether you walk, bike, or use public transportation. \n\nOur apartments feature GE stainless-steel Energy Star qualified appliances, gourmet style kitchens with sleek granite countertops, and contemporary tile backsplashes. Each unit includes in-home washers and dryers, spacious walk-in closets, and modern satin hardware. With 9' ceilings and wood-style plank flooring, our apartments provide a stylish and comfortable living space. Come home to Central Station on Orange, where your stop is here.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f6c0d-556d-7560-8f12-04f4192848b3.webp",
      "featured_image_media": {
        "alt_text": "Living room and bedroom view of a modern apartment with elegant furniture and balcony access.",
        "public_id": "019f6c0d-556d-7560-8f12-04f4192848b3",
        "storage_key": "property/5697443643523072/019f6c0d-556d-7560-8f12-04f4192848b3.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f6c0d-6019-7095-89f6-416138ff5ff7.webp",
      "blank_image_media": {
        "alt_text": "Exterior of the apartment building",
        "public_id": "019f6c0d-6019-7095-89f6-416138ff5ff7",
        "storage_key": "property/5697443643523072/019f6c0d-6019-7095-89f6-416138ff5ff7.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Central Station on Orange | Apartments For Rent In Orlando FL Near Everest University North Orlando",
      "seo_description": "Find apartments for rent in Orlando FL near Everest University North Orlando at Central Station on Orange. Enjoy modern amenities and urban living in Downtown Orlando. Your stop is here.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "custom",
      "page_item_url": "apartments-for-rent-orlando-fl-near-valencia-college",
      "search_query": "Apartments For Rent In Orlando FL Near Valencia College East Campus",
      "category": "POI",
      "h1_title": "Apartments For Rent In Orlando FL Near Valencia College East Campus at Central Station on Orange",
      "h2_subtitle": "Live close to Valencia College East Campus with our modern apartments. Enjoy top-tier amenities and a prime Downtown Orlando location near Lake Eola.",
      "page_copy": "Discover the perfect apartments for rent in Orlando FL near Valencia College East Campus at Central Station on Orange. Located in the vibrant Downtown Orlando, near Lake Eola, our community offers a dynamic urban lifestyle with top-notch amenities. Enjoy the convenience of being close to Valencia College East Campus, home to the School of Arts and Entertainment, while taking advantage of our resort-style pool, two-story fitness center, and expansive rooftop deck with stunning views of the Orlando skyline. With LYMMO and SunRail nearby, commuting is effortless whether you walk, bike, or use public transportation. \n\nOur apartments feature GE stainless-steel Energy Star qualified appliances, gourmet style kitchens with sleek granite countertops, and contemporary tile backsplashes. Each unit includes in-home washers and dryers, spacious walk-in closets, and modern satin hardware. With 9' ceilings and wood-style plank flooring, our apartments provide a stylish and comfortable living space. Come home to Central Station on Orange, where your stop is here.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f6c0d-556d-7560-8f12-04f4192848b3.webp",
      "featured_image_media": {
        "alt_text": "Living room and bedroom view of a modern apartment with elegant furniture and balcony access.",
        "public_id": "019f6c0d-556d-7560-8f12-04f4192848b3",
        "storage_key": "property/5697443643523072/019f6c0d-556d-7560-8f12-04f4192848b3.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f6c0d-6019-7095-89f6-416138ff5ff7.webp",
      "blank_image_media": {
        "alt_text": "Exterior of the apartment building",
        "public_id": "019f6c0d-6019-7095-89f6-416138ff5ff7",
        "storage_key": "property/5697443643523072/019f6c0d-6019-7095-89f6-416138ff5ff7.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Central Station on Orange | Apartments For Rent In Orlando FL Near Valencia College East Campus",
      "seo_description": "Find apartments for rent in Orlando FL near Valencia College East Campus at Central Station on Orange. Enjoy modern amenities and urban living in Downtown Orlando. Your stop is here.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "custom",
      "page_item_url": "apartments-for-rent-orlando-fl-near-seminole-state-college",
      "search_query": "Apartments For Rent In Orlando FL Near Seminole State College - Sanford/Lake Mary Campus",
      "category": "POI",
      "h1_title": "Apartments For Rent In Orlando FL Near Seminole State College - Sanford/Lake Mary Campus at Central Station on Orange",
      "h2_subtitle": "Live close to Seminole State College with our modern apartments. Enjoy top-tier amenities and a prime Downtown Orlando location near Lake Eola.",
      "page_copy": "Discover the perfect apartments for rent in Orlando FL near Seminole State College - Sanford/Lake Mary Campus at Central Station on Orange. Located in the vibrant Downtown Orlando, near Lake Eola, our community offers a dynamic urban lifestyle with top-notch amenities. Enjoy the convenience of being close to Seminole State College while taking advantage of our resort-style pool, two-story fitness center, and expansive rooftop deck with stunning views of the Orlando skyline. With LYMMO and SunRail nearby, commuting is effortless whether you walk, bike, or use public transportation. \n\nOur apartments feature GE stainless-steel Energy Star qualified appliances, gourmet style kitchens with sleek granite countertops, and contemporary tile backsplashes. Each unit includes in-home washers and dryers, spacious walk-in closets, and modern satin hardware. With 9' ceilings and wood-style plank flooring, our apartments provide a stylish and comfortable living space. Come home to Central Station on Orange, where your stop is here.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f6c0d-556d-7560-8f12-04f4192848b3.webp",
      "featured_image_media": {
        "alt_text": "Living room and bedroom view of a modern apartment with elegant furniture and balcony access.",
        "public_id": "019f6c0d-556d-7560-8f12-04f4192848b3",
        "storage_key": "property/5697443643523072/019f6c0d-556d-7560-8f12-04f4192848b3.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f6c0d-6019-7095-89f6-416138ff5ff7.webp",
      "blank_image_media": {
        "alt_text": "Exterior of the apartment building",
        "public_id": "019f6c0d-6019-7095-89f6-416138ff5ff7",
        "storage_key": "property/5697443643523072/019f6c0d-6019-7095-89f6-416138ff5ff7.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Central Station on Orange | Apartments For Rent In Orlando FL Near Seminole State College - Sanford/Lake Mary Campus",
      "seo_description": "Find apartments for rent in Orlando FL near Seminole State College - Sanford/Lake Mary Campus at Central Station on Orange. Enjoy modern amenities and urban living in Downtown Orlando. Your stop is here.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "custom",
      "page_item_url": "apartments-for-rent-in-orlando-near-cornerstone-academy",
      "search_query": "Apartments For Rent In Orlando FL Near Cornerstone Charter Academy",
      "category": "POI",
      "h1_title": "Apartments For Rent In Orlando FL Near Cornerstone Charter Academy at Central Station on Orange",
      "h2_subtitle": "Live close to Cornerstone Charter Academy with our family-friendly apartments. Enjoy modern amenities and a prime Downtown Orlando location near Lake Eola.",
      "page_copy": "Discover the perfect apartments for rent in Orlando FL near Cornerstone Charter Academy at Central Station on Orange. Located just 15.7 km from Cornerstone Charter Academy, our community offers a convenient and family-friendly living experience. Enjoy the benefits of being in the Cornerstone Charter Academy district while taking advantage of our resort-style pool, two-story fitness center, and expansive rooftop deck with stunning views of the Orlando skyline. With LYMMO and SunRail nearby, commuting is effortless whether you walk, bike, or use public transportation. \n\nOur available floor plans include studio, one, two, and three-bedroom apartments, each featuring GE stainless-steel Energy Star qualified appliances, gourmet style kitchens with sleek granite countertops, and contemporary tile backsplashes. Each unit includes in-home washers and dryers, spacious walk-in closets, and modern satin hardware. With 9' ceilings and wood-style plank flooring, our apartments provide a stylish and comfortable living space. Come home to Central Station on Orange, where your stop is here.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f6c0d-556d-7560-8f12-04f4192848b3.webp",
      "featured_image_media": {
        "alt_text": "Living room and bedroom view of a modern apartment with elegant furniture and balcony access.",
        "public_id": "019f6c0d-556d-7560-8f12-04f4192848b3",
        "storage_key": "property/5697443643523072/019f6c0d-556d-7560-8f12-04f4192848b3.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f6c0d-6019-7095-89f6-416138ff5ff7.webp",
      "blank_image_media": {
        "alt_text": "Exterior of the apartment building",
        "public_id": "019f6c0d-6019-7095-89f6-416138ff5ff7",
        "storage_key": "property/5697443643523072/019f6c0d-6019-7095-89f6-416138ff5ff7.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Central Station on Orange | Apartments For Rent In Orlando FL Near Cornerstone Charter Academy",
      "seo_description": "Find apartments for rent in Orlando FL near Cornerstone Charter Academy at Central Station on Orange. Enjoy modern amenities and urban living in Downtown Orlando. Your stop is here.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "custom",
      "page_item_url": "apartments-for-rent-orlando-fl-near-lake-como-school",
      "search_query": "Apartments For Rent In Orlando FL Near Lake Como School",
      "category": "POI",
      "h1_title": "Apartments For Rent In Orlando FL Near Lake Como School at Central Station on Orange",
      "h2_subtitle": "Enjoy family-friendly living close to Lake Como School. Our modern apartments offer top-tier amenities and a prime Downtown Orlando location near Lake Eola.",
      "page_copy": "Discover the ideal apartments for rent in Orlando FL near Lake Como School at Central Station on Orange. Located just 11.2 km from Lake Como School, our community offers a convenient and family-friendly living experience. Enjoy the benefits of being in the Lake Como School district while taking advantage of our resort-style pool, two-story fitness center, and expansive rooftop deck with stunning views of the Orlando skyline. With LYMMO and SunRail nearby, commuting is effortless whether you walk, bike, or use public transportation. \n\nOur available floor plans include studio, one, two, and three-bedroom apartments, each featuring GE stainless-steel Energy Star qualified appliances, gourmet style kitchens with sleek granite countertops, and contemporary tile backsplashes. Each unit includes in-home washers and dryers, spacious walk-in closets, and modern satin hardware. With 9' ceilings and wood-style plank flooring, our apartments provide a stylish and comfortable living space. Come home to Central Station on Orange, where your stop is here.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f6c0d-556d-7560-8f12-04f4192848b3.webp",
      "featured_image_media": {
        "alt_text": "Living room and bedroom view of a modern apartment with elegant furniture and balcony access.",
        "public_id": "019f6c0d-556d-7560-8f12-04f4192848b3",
        "storage_key": "property/5697443643523072/019f6c0d-556d-7560-8f12-04f4192848b3.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f6c0d-6019-7095-89f6-416138ff5ff7.webp",
      "blank_image_media": {
        "alt_text": "Exterior of the apartment building",
        "public_id": "019f6c0d-6019-7095-89f6-416138ff5ff7",
        "storage_key": "property/5697443643523072/019f6c0d-6019-7095-89f6-416138ff5ff7.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Central Station on Orange | Apartments For Rent In Orlando FL Near Lake Como School",
      "seo_description": "Find apartments for rent in Orlando FL near Lake Como School at Central Station on Orange. Enjoy modern amenities and urban living in Downtown Orlando. Your stop is here.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "custom",
      "page_item_url": "apartments-for-rent-orlando-fl-near-edgewater-high",
      "search_query": "Apartments For Rent In Orlando FL Near Edgewater High School",
      "category": "POI",
      "h1_title": "Apartments For Rent In Orlando FL Near Edgewater High School at Central Station on Orange",
      "h2_subtitle": "Enjoy family-friendly living close to Edgewater High School. Our modern apartments offer top-tier amenities and a prime Downtown Orlando location near Lake Eola.",
      "page_copy": "Discover the ideal apartments for rent in Orlando FL near Edgewater High School at Central Station on Orange. Located just 5.5 km from Edgewater High School, our community offers a convenient and family-friendly living experience. Enjoy the benefits of being in the Edgewater High School district while taking advantage of our resort-style pool, two-story fitness center, and expansive rooftop deck with stunning views of the Orlando skyline. With LYMMO and SunRail nearby, commuting is effortless whether you walk, bike, or use public transportation. \n\nOur available floor plans include studio, one, two, and three-bedroom apartments, each featuring GE stainless-steel Energy Star qualified appliances, gourmet style kitchens with sleek granite countertops, and contemporary tile backsplashes. Each unit includes in-home washers and dryers, spacious walk-in closets, and modern satin hardware. With 9' ceilings and wood-style plank flooring, our apartments provide a stylish and comfortable living space. Come home to Central Station on Orange, where your stop is here.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f6c0d-556d-7560-8f12-04f4192848b3.webp",
      "featured_image_media": {
        "alt_text": "Living room and bedroom view of a modern apartment with elegant furniture and balcony access.",
        "public_id": "019f6c0d-556d-7560-8f12-04f4192848b3",
        "storage_key": "property/5697443643523072/019f6c0d-556d-7560-8f12-04f4192848b3.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f6c0d-6019-7095-89f6-416138ff5ff7.webp",
      "blank_image_media": {
        "alt_text": "Exterior of the apartment building",
        "public_id": "019f6c0d-6019-7095-89f6-416138ff5ff7",
        "storage_key": "property/5697443643523072/019f6c0d-6019-7095-89f6-416138ff5ff7.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Central Station on Orange | Apartments For Rent In Orlando FL Near Edgewater High School",
      "seo_description": "Find apartments for rent in Orlando FL near Edgewater High School at Central Station on Orange. Enjoy modern amenities and urban living in Downtown Orlando. Your stop is here.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697443643523072",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-cornerstone-charter-academy",
      "search_query": "Apartments For Rent In Orlando FL Near Cornerstone Charter Academy",
      "category": "POI",
      "h1_title": "Apartments For Rent In Orlando FL Near Cornerstone Charter Academy at Central Station on Orange",
      "h2_subtitle": "Enjoy family-friendly living close to Cornerstone Charter Academy. Our modern apartments offer top-tier amenities and a prime Downtown Orlando location near Lake Eola.",
      "page_copy": "Discover the ideal apartments for rent in Orlando FL near Cornerstone Charter Academy at Central Station on Orange. Located just 15.7 km from Cornerstone Charter Academy, our community offers a convenient and family-friendly living experience. Enjoy the benefits of being in the Cornerstone Charter Academy district while taking advantage of our resort-style pool, two-story fitness center, and expansive rooftop deck with stunning views of the Orlando skyline. With LYMMO and SunRail nearby, commuting is effortless whether you walk, bike, or use public transportation. \n\nOur available floor plans include studio, one, two, and three-bedroom apartments, each featuring GE stainless-steel Energy Star qualified appliances, gourmet style kitchens with sleek granite countertops, and contemporary tile backsplashes. Each unit includes in-home washers and dryers, spacious walk-in closets, and modern satin hardware. With 9' ceilings and wood-style plank flooring, our apartments provide a stylish and comfortable living space. Come home to Central Station on Orange, where your stop is here.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f6c0d-556d-7560-8f12-04f4192848b3.webp",
      "featured_image_media": {
        "alt_text": "Living room and bedroom view of a modern apartment with elegant furniture and balcony access.",
        "public_id": "019f6c0d-556d-7560-8f12-04f4192848b3",
        "storage_key": "property/5697443643523072/019f6c0d-556d-7560-8f12-04f4192848b3.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019f6c0d-6019-7095-89f6-416138ff5ff7.webp",
      "blank_image_media": {
        "alt_text": "Exterior of the apartment building",
        "public_id": "019f6c0d-6019-7095-89f6-416138ff5ff7",
        "storage_key": "property/5697443643523072/019f6c0d-6019-7095-89f6-416138ff5ff7.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Central Station on Orange | Apartments For Rent In Orlando FL Near Cornerstone Charter Academy",
      "seo_description": "Find apartments for rent in Orlando FL near Cornerstone Charter Academy at Central Station on Orange. Enjoy modern amenities and urban living in Downtown Orlando. Your stop is here.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2150"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2376471454"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a21\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a21\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4816241"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KFZNQV8"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "1"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_betterbot_script",
      "type": "STRING",
      "value": "<script src=\"https://centralsta.engine.betterbot.com/loader.js\" defer=\"defer\"></script>"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8443831912"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/40vlm3nlple"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/42421969-23ab-4921-a892-f5b26e5e750a"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "407-559-5465"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImEzUWFvUEtsRGpoSmViUHBxNjgyanc9PSIsInZhbHVlIjoiWW52Mzl5eXhvSWZnZWtLWGNxejM3UT09IiwibWFjIjoiNTM0NGFiNzAzMzNkNjJhNDNkODI2NmZiY2ZhM2Q2YWNlN2ZjODlhYjY2OGY3MjRjYTU4MzBiNjYxZjc3ZjMyYiJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2150",
  "custom_repli_id": "2376471454",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a21\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a21\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4816241",
  "custom_google_gtm_id": "GTM-KFZNQV8",
  "custom_rollout_phase": "1",
  "custom_ads_subscription": "full_stack",
  "custom_betterbot_script": "<script src=\"https://centralsta.engine.betterbot.com/loader.js\" defer=\"defer\"></script>",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8443831912",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/40vlm3nlple",
  "custom_self_guided_tour_url": "https://selftournow.com/property/42421969-23ab-4921-a892-f5b26e5e750a",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "407-559-5465",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImEzUWFvUEtsRGpoSmViUHBxNjgyanc9PSIsInZhbHVlIjoiWW52Mzl5eXhvSWZnZWtLWGNxejM3UT09IiwibWFjIjoiNTM0NGFiNzAzMzNkNjJhNDNkODI2NmZiY2ZhM2Q2YWNlN2ZjODlhYjY2OGY3MjRjYTU4MzBiNjYxZjc3ZjMyYiJ9",
  "custom_household_income_qualification_multiplier": "3",
  "custom_audioeye_site_id": "5a0b7537-c5f8-4472-ac65-ad54519e54a2",
  "custom_audioeye_site_hash": "78a4634924d238a70cd3788ef6a1dc56"
};

export const generatedAt = '2026-10-19T17:06:12.908Z';
